/* prettier-ignore-file */

import { APP_PRODUCT_NAME } from "@/utils/global-constants";
import i18next from "i18next";
import { initReactI18next, useTranslation as useTranslationOriginal } from "react-i18next";

i18next.use(initReactI18next).init({
  resources: {
    ko: {
      translation: {
        "selfSignup.patient.title": "{{PRODUCT_NAME}} 치료 어플리케이션 사용을 위해 아이 정보를 입력해주세요.",
        "selfSignup.patient.childName": "환자 이름",
        "selfSignup.patient.placeholderChildName": "환자 이름을 입력해주세요",
        "selfSignup.patient.gender": "성별",
        "selfSignup.patient.birthDate": "생년월일",
        "selfSignup.summary.confirm": "작성하신 자녀 정보로 환자 등록을 진행하시겠습니까?",
        "selfSignup.summary.childName": "자녀 이름",
        "selfSignup.summary.gender": "성별",
        "selfSignup.summary.birthDate": "생년월일",
        "selfSignup.summary.guardianName": "보호자 이름",
        "selfSignup.summary.guardianPhone": "보호자 전화번호",
        "selfSignup.summary.guardianEmail": "보호자 이메일",
        "selfSignup.summary.submit": "위의 내용으로 환자 등록 하기",
        "selfSignup.guardian.title": "{{PRODUCT_NAME}} 치료 어플리케이션 사용을 위해 보호자 정보를 입력해주세요.",
        "selfSignup.guardian.name": "보호자 이름",
        "selfSignup.guardian.placeholderName": "보호자 이름을 입력해주세요",
        "selfSignup.guardian.phone": "보호자 전화번호",
        "selfSignup.guardian.authCompleted": "인증되었습니다",
        "selfSignup.guardian.authCode": "인증번호",
        "selfSignup.guardian.emailOptional": "보호자 이메일(선택)",
        "selfSignup.cancel.title": "등록이 취소되었습니다.",
        "selfSignup.cancel.description": "화면을 닫아주세요.",
        "selfSignup.complete.title": "환자 등록 신청이 완료되었습니다!",
        "selfSignup.complete.description1": "담당 의료진의 승인 후 입력하신 휴대폰 번호로 계정 생성링크가 발송됩니다.",
        "selfSignup.complete.description2": "링크를 통해 계정을 생성하시면 치료 프로그램을 이용하실 수 있습니다.",
        "selfSignup.complete.note": "※ 문자가 오지 않을 경우 스팸차단을 확인해 주세요.",
        "selfSignup.bottomSheet.dataError.title": "데이터 오류",
        "selfSignup.bottomSheet.dataError.description": "바텀시트에 필요한 데이터가 누락되었습니다.",
        "selfSignup.bottomSheet.dataError.errorType": "에러 타입",
        "selfSignup.bottomSheet.dataError.missingFields": "누락된 필드",
        "selfSignup.bottomSheet.dataError.developerNote": "개발자 참고: 각 에러 타입에 맞는 올바른 데이터를 전달해주세요.",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.title": "이미 등록된 보호자입니다",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.description": "해당 전화번호로 이미 등록된 보호자가 있습니다.",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.detailInfo": "등록된 환자: ({{patientName}})",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.okButton": "확인",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.cancelButton": "취소",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.title": "이미 등록된 환자입니다",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.description": "해당 정보로 이미 등록된 환자가 있습니다.",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.patientNameGender": "환자명/성별",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.birthDate": "생년월일",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.guardianName": "보호자명",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.guardianPhoneNumber": "보호자 전화번호",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.guardianEmail": "보호자 이메일",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.okButton": "확인",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.cancelButton": "취소",
        "selfSignup.bottomSheet.alreadyReadySignup.title": "등록 대기 중인 환자입니다",
        "selfSignup.bottomSheet.alreadyReadySignup.description": "해당 정보로 이미 등록 신청이 진행 중입니다.",
        "selfSignup.bottomSheet.alreadyReadySignup.patientNameGender": "환자명/성별",
        "selfSignup.bottomSheet.alreadyReadySignup.birthDate": "생년월일",
        "selfSignup.bottomSheet.alreadyReadySignup.guardianName": "보호자명",
        "selfSignup.bottomSheet.alreadyReadySignup.guardianPhoneNumber": "보호자 전화번호",
        "selfSignup.bottomSheet.alreadyReadySignup.guardianEmail": "보호자 이메일",
        "selfSignup.bottomSheet.alreadyReadySignup.okButton": "확인",
        "selfSignup.bottomSheet.alreadyReadySignup.cancelButton": "취소",
        "common.close": "닫기",
        "common.errorCode": "(에러코드 : {{code}})",
        "common.patient": "환자",
        "common.day": "차",
        "common.previous": "이전",
        "common.next": "다음",
        "common.count": "횟수",
        "common.times": "회",
        "common.coordinate": "좌표",
        "common.xCoordinate": "X 좌표",
        "common.yCoordinate": "Y 좌표",
        "common.eyePosition": "움직임 횟수",
        "common.loadingChart": "차트를 불러오는 중...",
        "common.dayProgress": "({{day}}일 차)",
        "activityChart.chartDescription": "환자가 치료 활동을 진행하는 동안 실시간으로 측정된 눈동자의 움직임 좌표를 시각화한 그래프입니다.",
        "activityChart.xAxisHint": "(좌우 움직임)",
        "activityChart.yAxisHint": "(상하 움직임)",
        "activityChart.timeLabel": "시간 (초)",
        "activityChart.gazePosition": "시선 위치",
        "activityChart.gazePositionX": "시선 위치 (X축)",
        "activityChart.gazePositionY": "시선 위치 (Y축)",
        "common.addPatient": "환자 추가",
        "common.toast.patientPending": "환자가 등록 대기중입니다.",
        "common.toast.registerButton": "등록하기",
        "common.toast.unknownError": "알 수 없는 에러가 발생했습니다.",
        "common.auth.sendCode": "인증번호 전송",
        "common.auth.resendCode": "인증번호 재전송",
        "selfSignup.header.title": "자녀 등록",
        "selfSignup.welcome.greeting": "안녕하세요.",
        "selfSignup.welcome.hospitalSuffix": " 병원 입니다.",
        "selfSignup.welcome.needRegistrationLine1": "SAT001을 시작하기 위해",
        "selfSignup.welcome.needRegistrationLine2": "자녀 등록이 필요합니다.",
        "selfSignup.welcome.privacyNotice": "본인 인증 시 수집된 개인정보는 서비스 이외 다른 용도로 사용되지 않습니다.",
        "selfSignup.welcome.startRegistration": "등록 시작하기",
        "selfSignup.notAllowed.title": "접근 제한",
        "selfSignup.notAllowed.message": "승인 되지 않은 병원 코드입니다.",
        "selfSignup.notAllowed.description": "올바른 병원 코드로 다시 시도해주세요.",
        "appAccount.checkName.description": "{{APP_PRODUCT_NAME}}의 아이디, 비밀번호\n 설정을 위해 본인확인을 진행해주세요.",
        "appAccount.checkName.guardianName": "보호자 이름",
        "appAccount.checkName.placeholderGuardianName": "이름을 입력해주세요",
        "appAccount.common.checking": "확인 중...",
        "appAccount.complete.title": "계정 설정이 완료되었습니다.",
        "appAccount.complete.description": "설정한 계정으로 {{APP_PRODUCT_NAME}}을 시작할 수 있습니다.",
        "appAccount.complete.hint": "아래 로그인하기 버튼을 눌러\n{{APP_PRODUCT_NAME}}을 시작해보세요.",
        "appAccount.complete.login": "로그인 하기",
        "appAccount.expired.title": "계정 설정 링크가 만료되었습니다.",
        "appAccount.expired.beforeSetup": "<point>계정 설정 전</point>이라면, 등록하신 병원에 계정 설정 메세지 재전송을 요청하세요.",
        "appAccount.expired.afterSetup": "<point>계정 설정을 완료</point>하셨다면, {{APP_PRODUCT_NAME}}을 시작하세요.",
        "appAccount.common.next": "다음",
        "appAccount.common.userId": "아이디",
        "appAccount.common.password": "비밀번호",
        "appAccount.setupAccount.description": "{{APP_PRODUCT_NAME}}의 아이디, 비밀번호를 설정해주세요.",
        "appAccount.setupAccount.placeholderUserId": "아이디를 입력하세요",
        "appAccount.setupAccount.placeholderPassword": "비밀번호를 입력하세요",
        "appAccount.setupAccount.passwordConfirm": "비밀번호 확인",
        "appAccount.setupAccount.placeholderPasswordConfirm": "비밀번호를 한번 더 입력하세요",
        "findPassword.requestComplete.title": "메일 전송을 완료했습니다.",
        "findPassword.requestComplete.sentTo": "비밀번호 재설정 이메일을",
        "findPassword.requestComplete.setNewPassword": "새로운 비밀번호를 설정해 주세요.",
        "findPassword.requestComplete.checkSpam": "메일이 도착하지 않은 경우 스팸메일 폴더를 확인해 주세요.",
        "findPassword.token.title": "비밀번호 재설정",
        "findPassword.token.placeholderNewPassword": "새 비밀번호를 입력해주세요",
        "findPassword.token.placeholderConfirmPassword": "비밀번호를 재입력해 주세요",
        "findPassword.token.submit": "비밀번호 변경하기",
        "findPassword.codeValidation.title": "비밀번호 재설정 코드 입력",
        "findPassword.codeValidation.description": "로 발송된 비밀번호 재설정 코드를 입력해주세요.",
        "findPassword.common.next": "다음",
        "findPassword.requestLink.title": "비밀번호 찾기",
        "findPassword.requestLink.description": "비밀번호 재설정 코드를 전송받을 이메일을 입력하세요.",
        "findPassword.requestLink.placeholderEmail": "이메일을 입력해주세요",

        "findPassword.viewModel.error.title": "오류 발생",
        "findPassword.viewModel.error.description": "알 수 없는 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
        "findPassword.viewModel.error.confirm": "확인",
        "findPassword.viewModel.invalidToken.title": "유효하지 않은 토큰",
        "findPassword.viewModel.invalidToken.description": "비밀번호 재설정 링크가 유효하지 않습니다. 로그인 화면으로 이동합니다.",
        "findPassword.viewModel.passwordMismatch": "비밀번호가 일치하지 않습니다.",
        "findPassword.viewModel.passwordChangeComplete.title": "비밀번호 변경 완료",
        "findPassword.viewModel.passwordChangeComplete.description": "비밀번호 변경이 완료되었습니다. 로그인 화면으로 이동합니다.",
        "findPassword.viewModel.passwordValidation.length": "8-20자리",
        "findPassword.viewModel.passwordValidation.letter": "영문자 포함",
        "findPassword.viewModel.passwordValidation.number": "숫자 포함",
        "findPassword.viewModel.passwordValidation.special": "특수문자(!@#$%^&*) 포함",
        "findPassword.viewModel.console.emailChange": "이메일 변경 시 기존 에러 메시지 클리어",
        "common.ok": "확인",
        "common.agree": "동의",
        "common.gender.male": "남자",
        "common.gender.female": "여자",
        "common.date.format": "{{year}}년 {{month}}월 {{day}}일",
        "common.activity.LeftRightRail": "좌우 레일",
        "common.activity.Rotation": "회전",
        "common.activity.UpDown": "상하",
        "common.activity.FourWay": "상하좌우",
        "common.activity.LeftRightRepeat": "좌우 반복",
        "common.activityState.notStarted": "진행하지 않음",
        "common.activityState.inProgress": "부분진행",
        "common.activityState.completed": "완료",

        "footer.medical.device.info": "의료기기 정보",
        "footer.terms": "서비스 이용약관",
        "footer.privacy": "개인정보 처리방침",
        "footer.language": "한국어",

        "language.ko": "한국어",
        "language.en": "English",
        "language.ja": "日本語",
        "footer.console.excludePath": "EXCLUDE_FOOTER_PATH 경로에 포함되어 푸터를 표시하지 않습니다.",

        "login.email": "이메일을 입력하세요",
        "login.password": "비밀번호를 입력하세요",
        "login.forgotPassword": "비밀번호 찾기",
        "login.signIn": "로그인",
        "login.signUp": "회원가입",
        "login.warning.registeredUsersOnly": "본 시스템은 등록된 사용자만 접근할 수 있습니다.",
        "login.warning.monitoringAndRecording": "시스템 사용은 모니터링 및 기록 대상이 되며, 무단 사용 시 민/형사상 처벌을 받을 수 있습니다.",
        "login.warning.loginAgreement": "로그인은 사용 조건에 동의함을 의미합니다.",
        "login.remember": "이메일 저장하기",
        "login.error": "로그인에 실패했습니다. 다시 시도해주세요.",
        "login.browserWarning.title": "다른 브라우저 사용을 권장합니다",
        "login.browserWarning.description": "현재 브라우저에서는 일부 기능이 제한될 수 있습니다. 크롬(Chrome) 또는 엣지(Edge) 브라우저 사용을 권장합니다.",
        "login.browserWarning.okButton": "확인",
        "common.timeZoneDetection.title": "시간 위변조 탐지",
        "common.timeZoneDetection.description": "시간 위변조가 탐지되었습니다. 현재 설정된 시간이 올바른지 확인하고 다시 로그인 해주세요.",
        "common.loading": "로딩중...",
        "common.processing": "처리중...",

        "home.searchBarPlaceholder": "환자 이름으로 검색하세요.",
        "home.titleAddNewPatient": "<b>신규 환자를 등록</b>하세요",
        "home.addPatientByQR": "QR 간편 등록",
        "home.addPatientByDoctor": "환자 등록",
        "home.titleAddNewPrescription": "<b>등록 환자를 확인</b>하고<br /> <b>치료를 추가</b>하세요",
        "home.inProgressPatient": "치료 중인 환자",
        "home.personCountUnit": "명",
        "home.showPatientList": "환자 목록 보기",
        "home.searchHelp": "환자 이름을 입력해 검색해주세요",
        "home.actionLogs": "액션 로그",

        "patientList.patientNumber": "환자 번호",
        "patientList.title": "환자 목록",
        "patientList.name": "환자 이름/성별",
        "patientList.deactive": "비활성화",
        "patientList.birthDay": "생년월일",
        "patientList.progress": "치료 정보(치료 단계/상태/참여도)",
        "patientList.memo": "메모",
        "patientList.info": "환자 정보",
        "patientList.filterPrescriptionAdd": "치료 기간 설정이 가능한 환자 보기",
        "patientList.filterByName": "이름으로 검색하기",
        "patientList.filterByPatientNumber": "환자 번호로 검색하기",
        "patientList.doctor": "선생님",
        "patientList.emptyPatient": "등록된 환자가 없습니다.",
        "patientList.emptyPatientWithAddPrescriptionAvailable": "치료 등록이 가능한 환자가 없습니다.",
        "patientList.emptyFilteredPatient": "일치하는 환자가 없습니다.",
        "patientList.emptyFilteredPatientWithName": "'<strong>{{name}}</strong>' 환자를 등록해주세요.",
        "patientList.stepVisit": "{{step}}차 진료",
        "patientList.progressInfo.inProgress": "진행중",
        "patientList.progressInfo.completed": "완료",
        "patientList.progressInfo.notStarted": "시작 전",
        "patientList.progressInfo.interrupted": "중단",
        "patientList.progressInfo.canceled": "취소",
        "patientList.progressInfo.noActivityStepsInProgress": "진행 중인 활동 단계 없음",
        "patientList.progressInfo.beforeStart": "시작 전",
        "patientList.addTreatmentBt": "치료 기간 설정",
        "patientList.birthdayWithAge": "{{date}}/만 {{age}}세",

        "addTreatment.title": "치료 등록",
        "addTreatment.patientInfo": "환자 정보",
        "addTreatment.patientNameGender": "환자 이름/성별",
        "addTreatment.birthDate": "생년월일",
        "addTreatment.treatmentInfo": "치료 정보",
        "addTreatment.treatmentStep": "치료 차수",
        "addTreatment.treatmentPeriod": "치료 기간",
        "addTreatment.hospitalVisitDate": "병원 방문일",
        "addTreatment.hospitalVisitDescription": " 에 병원을 방문해 다음 차수 치료를 등록해주세요.",
        "addTreatment.memo": "메모",
        "addTreatment.memoPlaceholder": "특이사항이나 참고사항을 입력하세요",
        "addTreatment.cancel": "취소",
        "addTreatment.submit": "기간 설정하기",
        "addTreatment.treatmentStepUnit": "차 치료",
        "addTreatment.week14": "14주",
        "addTreatment.error.title": "치료 기간 설정 실패",
        "addTreatment.error.description": "치료 기간 설정에 실패했습니다.",

        "patientTreatmentInfoCard.title": "치료 현황",
        "patientTreatmentInfoCard.editTreatmentDuration": "치료 기간 설정",
        "patientTreatmentInfoCard.noData": "데이터가 없습니다.",
        "patientTreatmentInfoCard.columns.treatmentStep": "치료 단계",
        "patientTreatmentInfoCard.columns.period": "기간",
        "patientTreatmentInfoCard.columns.date": "날짜",
        "patientTreatmentInfoCard.columns.state": "상태",
        "patientTreatmentInfoCard.columns.activityTime": "활동 시간",
        "patientTreatmentInfoCard.columns.activityTimeSubHeader": "수행 시간(권장시간)",
        "patientTreatmentInfoCard.columns.adherence": "참여도",
        "patientTreatmentInfoCard.columns.doctor": "담당의",
        "patientTreatmentInfoCard.columns.dayLabel": "일차",
        "patientTreatmentInfoCard.summaryCard.inProgressTreatment": "진행 중인 치료 현황",
        "patientTreatmentInfoCard.summaryCard.totalAdherence": "전체 참여도",
        "patientTreatmentInfoCard.stepUnit": "차",
        "patientTreatmentInfoCard.units.step": "차",
        "patientTreatmentInfoCard.units.day": "일차",
        "patientTreatmentInfoCard.units.minute": "분",

        "patientDetail.error.title": "환자 상세 정보 로딩 실패",
        "patientDetail.error.description": "환자 상세 정보 로딩에 실패했습니다. 잠시 후 다시 시도해주시기 바랍니다.",
        "patientDetail.button.confirm": "확인",
        "patientDetail.emptyTreatmentCard.noTreatment": "진행 중인 치료가 없습니다.",
        "patientDetail.deactivatedInfoLabel": "비활성화 된 환자입니다. 치료 추가, 정보 수정등을 위해서는 비활성화를 해제해주세요.",
        "patientDetail.activate": "비활성화 해제",
        "patientDetail.showChart": "차트 보기",
        "patientDetail.showDetail": "상세보기",
        "patientDetail.lightEstimation": "밝은 빛 인증",

        "patientGuardianInputForm.guardianInfo": "보호자 정보",
        "patientGuardianInputForm.patientInfo": "환자 정보",
        "patientGuardianInputForm.patientName": "환자 이름/성별",
        "patientGuardianInputForm.patientNamePlaceholder": "홍길동",
        "patientGuardianInputForm.patientBirthDate": "생년월일",
        "patientGuardianInputForm.patientGender": "환자 성별",
        "patientGuardianInputForm.patientMemo": "메모",
        "patientGuardianInputForm.guardianName": "보호자 이름",
        "patientGuardianInputForm.guardianNamePlaceholder": "홍길동",
        "patientGuardianInputForm.guardianPhoneNumber": "보호자 전화번호",
        "patientGuardianInputForm.guardianEmail": "보호자 이메일",
        "patientGuardianInputForm.required": "필수",
        "patientGuardianInputForm.optional": "선택",

        "breadcrumbs.home": "홈",
        "breadcrumbs.profile": "프로필 정보",
        "breadcrumbs.patientList": "환자 목록",
        "breadcrumbs.addPatient": "환자 등록",
        "breadcrumbs.patientDetail": "환자 상세",
        "breadcrumbs.addTreatment": "치료 기간 설정",
        "breadcrumbs.treatmentProgress": "치료 진행 현황",
        "breadcrumbs.medicalDeviceInfo": "의료기기 정보",
        "breadcrumbs.adminHome": "관리자 홈",
        "breadcrumbs.adminDoctors": "의료진 관리",
        "breadcrumbs.doctorDetail": "의료진 상세",
        "breadcrumbs.adminHospitals": "병원 목록",
        "breadcrumbs.adminAddHospital": "병원 추가",
        "breadcrumbs.adminPatients": "환자 목록",
        "breadcrumbs.adminLogs": "로그",
        "breadcrumbs.adminActionLogs": "액션 로그",
        "breadcrumbs.actionLogs": "액션 로그",
        "breadcrumbs.adminAddDoctor": "의료진 추가",
        "breadcrumbs.adminEditNotice": "공지 수정",
        "breadcrumbs.adminAddNotice": "공지 추가",
        "breadcrumbs.adminNotices": "공지사항",
        "breadcrumbs.noticeDetail": "공지 상세",
        "breadcrumbs.myInfo": "내 정보",
        "breadcrumbs.passwordChange": "비밀번호 변경",

        "errorPage.defaultMessage": "문제가 발생했습니다. 잠시 후 다시 시도해 주세요.",
        "errorPage.error": "Error",
        "errorPage.retry": "다시 시도",
        "errorPage.contact": "문의: salpha@salphadtx.com",

        "phoneAuthCodeInput.placeholder": "발송된 인증번호 6자리를 입력하세요",

        "customDatepicker.dateSelection": "날짜 선택",
        "customDatepicker.cancel": "취소",
        "customDatepicker.select": "선택",

        "qrModal.hospitalName": "병원 이름",
        "qrModal.scanQRCode": "보호자 스마트폰으로 QR 코드를 스캔하세요",
        "qrModal.useDefaultCamera": "기본 카메라 앱을 사용해주세요",
        "qrModal.directRegistration": "환자 정보 직접 등록하기",
        "qrModal.complete": "완료",
        "qrModal.close": "닫기",

        "header.userManual": "사용 가이드 보기",
        "header.hospital": "병원",
        "header.changePassword": "비밀번호 변경",
        "header.logout": "로그아웃",
        "header.doctor": "{{doctorName}} 선생님",
        "header.console.registerAction": "등록 하기",
        "header.console.logoutAction": "기본 로그아웃 로직 실행",

        "patientInfoCard.accountSetupMessageResend": "계정 설정 메시지 재전송",
        "patientInfoCard.editInfo": "정보 수정",
        "patientInfoCard.editInfoButton": "수정 완료",
        "patientInfoCard.patientNumber": "환자 번호",
        "patientInfoCard.guardianName": "보호자 이름",
        "patientInfoCard.guardianEmail": "보호자 email",
        "patientInfoCard.guardianContact": "보호자 전화번호",
        "patientInfoCard.memo": "메모",
        "patientInfoCard.noMemo": "-",

        "component.loading.text": "로딩중...",
        "component.dropdown.arrow": "화살표",
        "component.sectionGroup.deactivatePatient": "환자 비활성화",
        "component.sectionGroup.deactivateDoctor": "계정 비활성화",
        "validation.email.required": "이메일을 입력해주세요.",
        "validation.email.invalidFormat": "올바른 형식의 이메일 주소를 입력하세요.",
        "validation.password.required": "비밀번호를 입력해주세요.",
        "validation.password.conditions": "비밀번호 조건을 만족하지 않습니다.",
        "validation.password.changeComplete": "비밀번호 변경 완료",
        "validation.password.changeCompleteMessage": "비밀번호 변경이 완료되었습니다. 재 로그인이 필요합니다. 로그인 화면으로 이동합니다.",
        "password.change.initial.title": "초기 비밀번호 변경",
        "password.change.expired.title": "만료된 비밀번호 변경",
        "password.change.default.title": "비밀번호 변경",
        "password.change.initial.description": "더 안전한 서비스 이용을 위해 초기 비밀번호를 변경해주세요.",
        "password.change.expired.description": "더 안전한 서비스 이용을 위해 6개월 마다 새로운 비밀번호로 변경해 주세요.",
        "password.change.default.description": "새로운 비밀번호로 변경해주세요.",
        "validation.userId.required": "아이디를 입력해주세요.",
        "validation.userId.length": "6-16자 이내",
        "validation.userId.format": "영소문자, 숫자만 사용 가능",
        "validation.userId.duplicate": "이미 사용중인 아이디입니다.",
        "validation.password.confirmRequired": "비밀번호 확인을 입력해주세요.",
        "validation.password.minimum": "비밀번호는 8자 이상이어야 합니다.",
        "validation.phone.invalidFormat": "휴대폰 번호 형식이 올바르지 않습니다.",
        "validation.phone.required": "전화번호를 입력하세요.",
        "validation.phone.authRequired": "전화번호 인증을 완료해주세요.",
        "validation.phone.authInvalid": "인증번호가 올바르지 않습니다.",
        "validation.name.minimum": "이름은 2글자 이상 입력해주세요.",
        "validation.name.required": "이름을 입력해주세요.",
        "validation.name.noNumbers": "이름에는 숫자를 입력할 수 없습니다.",
        "validation.name.noSpecialChars": "이름에는 특수문자를 입력할 수 없습니다.",
        "validation.name.allowedChars": "이름은 한글, 영문, 공백만 입력 가능합니다.",
        "validation.name.invalidFormat": "올바른 이름 형식으로 입력해주세요.",
        "notice.validation.titleEmpty": "제목을 입력해주세요",
        "notice.validation.contentEmpty": "내용을 입력해주세요",
        "notice.validation.endDateBeforeStartDate": "종료일이 시작일보다 앞서면 종료일을 시작일로 조정해주세요",
        "notice.validation.versionEmpty": "버전을 입력해주세요",
        "notice.validation.errorTitle": "공지사항 등록 오류",
        "notice.validation.confirmButton": "확인",
        "validation.birthDate.required": "생년월일을 선택하세요.",
        "validation.guardianName.minimum": "보호자 이름은 2글자 이상 입력해주세요.",
        "addTreatment.confirmEndCurrent": "현재 치료 종료 확인",
        "addTreatment.confirmEndCurrentDescription": "현재 진행중인 치료를 종료하고 새 치료를 시작하시겠습니까?",
        "patientDetail.updateFailed": "환자 정보 수정 실패",
        "patientDetail.updateComplete": "환자 정보 수정 완료",
        "patientDetail.updateCompleteMessage": "환자 정보가 수정되었습니다.",
        "patientDetail.deactivateTitle": "환자 계정 비활성화",
        "patientDetail.deactivateDescription": "환자 계정을 비활성화합니다. 진행중인 치료는 중단되며, 이후 치료 등록을 원할 시 비활성화를 해제해야합니다.",
        "doctorDetail.deactivateTitle": "의료진 계정 비활성화",
        "doctorDetail.deactivateDescription": "의료진 계정을 비활성화합니다. 로그인 및 모든 서비스 이용이 제한되며, 재사용 시 비활성화 해제가 필요합니다.",
        "doctorDetail.deactivatedInfoLabel": "비활성화 된 의사입니다. 로그인 및 정보 수정 등의 기능을 사용하려면 비활성화를 해제해주세요.",
        "doctorDetail.activate": "비활성화 해제",
        "patientDetail.activateTitle": "환자 계정 활성화",
        "patientDetail.activateDescription": "활성화 한 뒤에 치료이 가능해집니다. 계속 진행하시겠습니까?",
        "errorPage.networkError": "네트워크 오류 발생",
        "patientInfoCard.accountSetupMessageSent": "보호자 계정 생성을 위한 안내 문자를 발송했습니다. 확인 요청 해주세요.",
        "selfSignup.registrationFailed": "환자 등록 실패",
        "selfSignup.saveFailed": "환자 정보 저장에 실패했습니다. 다시 시도해주세요.",
        "selfSignup.saveFailedTitle": "저장 실패",
        "selfSignup.authCodeSendFailed": "인증번호 전송 실패",
        "addPatient.duplicatePatient": "이미 등록된 환자정보입니다",
        "addPatient.duplicatePatientDescription": "동일한 정보로 이미 등록된 환자가 있어 중복 등록이 불가능합니다. 작성하신 환자 정보를 확인해주세요.",
        "addPatient.reEnter": "다시 입력하기",
        "addPatient.viewRegisteredPatient": "등록된 환자 정보 보기",
        "addPatient.invalidGuardianPhoneNumberTitle": "보호자 전화번호를 확인해주세요",
        "addPatient.invalidGuardianPhoneNumberDescription": "입력하신 전화번호 ({{guardianPhoneNumber}})는 다른 환자의 보호자로 이미 등록되어 있습니다.",
        "addPatient.reInputGuardianPhoneNumber": "올바른 전화번호를 다시 입력해주세요",
        "common.cancel": "취소",
        "treatmentDetail.cancelComplete": "치료 취소 완료",
        "treatmentDetail.cancelCompleteMessage": "현재 치료가 정상적으로 취소 되었습니다. 환자 정보로 이동합니다.",
        "treatmentDetail.confirmStop": "치료 취소 확인",
        "treatmentDetail.confirmStopDescription": "진행 중인 치료를 취소하시겠습니까?",
        "treatmentDetail.chartDataLoadFailed": "치료 차트 데이터 조회 실패",
        "treatmentDetail.chartDataLoadFailedMessage": "치료 차트 데이터를 조회할 수 없습니다.",
        "findPassword.viewModel.authError": "이메일, 인증정보 오류",
        "findPassword.viewModel.authErrorMessage": "이메일 또는 인증정보 오류가 발생했습니다. 다시 시도해주세요.",
        "validation.guardianName.required": "보호자 이름을 입력해주세요.",
        "validation.guardianName.mismatch": "보호자 이름이 일치하지 않습니다.\n병원에 등록한 보호자 이름과 동일하게 입력해주세요",
        "passwordChange.currentPasswordPlaceholder": "현재 비밀번호를 입력해주세요",
        "passwordChange.newPasswordPlaceholder": "새 비밀번호를 입력해주세요",
        "passwordChange.confirmPasswordPlaceholder": "비밀번호를 재입력해 주세요",
        "passwordChange.changeButton": "비밀번호 변경하기",
        "treatmentDetail.summaryTitle": "{{step}}차 치료 내용 요약",
        "treatmentDetail.progressTitle": "{{step}}차 치료 진행 현황",
        "treatmentDetail.noProgressData": "진행 현황이 없습니다.",
        "treatmentDetail.memoPlaceholder": "특이사항이나 참고사항을 입력하세요.",
        "treatmentDetail.memoSave": "저장하기",
        "treatmentDetail.memoEdit": "수정하기",
        "treatmentDetail.stopTreatment": "치료 중단",
        "errorPage.tryAgainLater": "잠시후에 다시 시도해주세요.",
        "test.newKey1": "새로운 번역 키 1",
        "test.newKey2": "새로운 번역 키 2",
        "test.newKey3": "새로운 번역 키 3",
        "admin.doctorList.title": "의료진 조회",
        "admin.doctorList.searchPlaceholder": "이름, 병원 이름",
        "admin.doctorList.nameHeader": "의료진 이름",
        "admin.doctorList.licenseHeader": "면허 번호",
        "admin.doctorList.hospitalHeader": "소속 병원",
        "admin.doctorList.hospitalPhoneHeader": "병원 연락처",
        "admin.doctorList.treatmentCountHeader": "등록 치료 수",
        "admin.doctorList.emptySearchResult": "검색 결과가 없습니다.",
        "admin.doctorList.emptyList": "등록된 의료진이 없습니다.",
        "admin.doctorList.addDoctorPrompt": "의료진을 등록하시겠습니까?",
        "admin.doctorList.addDoctorButton": "의료진 추가",
        "admin.addDoctor.title": "의료진 등록",
        "admin.addDoctor.doctorNameLabel": "의료진 이름",
        "admin.addDoctor.doctorNamePlaceholder": "홍길동",
        "admin.addDoctor.licenseNumberLabel": "면허 번호",
        "admin.addDoctor.licenseNumberPlaceholder": "01-123456",
        "admin.addDoctor.hospitalLabel": "소속 병원",
        "admin.addDoctor.hospitalPlaceholder": "병원 이름을 입력하세요",
        "admin.addDoctor.hospitalPhoneLabel": "병원 전화번호",
        "admin.addDoctor.hospitalPhonePlaceholder": "02-1234-5678",
        "admin.addDoctor.doctorEmailLabel": "이메일",
        "admin.addDoctor.hospitalEmailLabel": "병원 이메일",
        "admin.addDoctor.emailPlaceholder": "salpha@salphadtx.com",
        "admin.addDoctor.memoLabel": "메모",
        "admin.addDoctor.memoPlaceholder": "특이사항이나 참고사항을 입력하세요",
        "admin.addDoctor.cancelButton": "취소",
        "admin.addDoctor.submitButton": "의료진 등록",
        "admin.addDoctor.successTitle": "의료진 등록 완료",
        "admin.addDoctor.successMessage": "의료진이 성공적으로 등록되었습니다.",
        "admin.addDoctor.doctorNameRequired": "의료진 이름을 입력해주세요.",
        "admin.addDoctor.licenseNumberRequired": "면허 번호를 입력해주세요.",
        "admin.addDoctor.hospitalRequired": "소속 병원을 입력해주세요.",
        "admin.addDoctor.selectHospital": "병원을 선택하세요",
        "admin.addDoctor.addHospital": "새 병원 등록하기",
        "admin.addDoctor.noHospitalFound": "검색된 병원이 없습니다",
        "admin.addDoctor.doctorEmailRequired": "이메일을 입력해주세요.",
        "admin.addDoctor.hospitalPhoneInvalid": "올바른 전화번호 형식을 입력해주세요.",
        "admin.addDoctor.registrationFailed": "의료진 등록에 실패했습니다. 다시 시도해주세요.",
        "admin.doctorDetail.editInfo": "정보 수정",
        "admin.doctorDetail.editTitle": "의료진 정보 수정",
        "admin.doctorDetail.editInfoButton": "설정 완료",
        "admin.doctorDetail.doctorNameLabel": "의료진 이름",
        "admin.doctorDetail.doctorNamePlaceholder": "의료진 이름을 입력하세요",
        "admin.doctorDetail.hospitalNamePlaceholder": "병원 이름을 입력하세요",
        "admin.doctorDetail.memoPlaceholder": "메모를 입력하세요",
        "admin.doctorDetail.doctorId": "의료진 Id",
        "admin.doctorDetail.email": "이메일",
        "admin.doctorDetail.hospital": "소속 병원",
        "admin.doctorDetail.memo": "메모",
        "admin.doctorDetail.registeredTreatments": "{{ProductName}} 등록한 치료 목록",
        "admin.doctorDetail.treatmentTable.createdAt": "등록 시간",
        "admin.doctorDetail.treatmentTable.patientId": "환자 ID",
        "admin.doctorDetail.treatmentTable.treatmentId": "치료 ID",
        "admin.doctorDetail.treatmentTable.stepAndPeriod": "등록 차수/기간",
        "admin.doctorDetail.treatmentTable.step": "Step",
        "admin.doctorDetail.treatmentTable.type": "Type",
        "admin.doctorDetail.treatmentTable.stepUnit": "차",
        "admin.doctorDetail.treatmentTable.weekUnit": "주",
        "admin.doctorDetail.treatmentTable.empty": "등록된 치료가 없습니다",
        "admin.doctorDetail.treatmentTable.cancelled": "취소됨",
        "admin.doctorDetail.treatmentCountLabel": "등록 치료 수",
        "admin.doctorDetail.filter.all": "전체",
        "admin.doctorDetail.filter.createdAt": "등록 시간",
        "admin.doctorDetail.filter.patientId": "환자 ID",
        "admin.doctorDetail.filter.treatmentId": "치료 ID",
        "admin.doctorDetail.filter.placeholder.all": "등록 시간, 환자 ID, 치료 ID로 검색",
        "admin.doctorDetail.filter.placeholder.createdAt": "등록 시간을 입력하세요 (예: 2024-01-01)",
        "admin.doctorDetail.filter.placeholder.patientId": "환자 ID를 입력하세요",
        "admin.doctorDetail.filter.placeholder.treatmentId": "치료 ID를 입력하세요",
        "admin.addHospital.title": "병원 정보",
        "admin.addHospital.hospitalNameLabel": "병원 이름",
        "admin.addHospital.hospitalNamePlaceholder": "병원 전체 이름을 입력하세요",
        "admin.addHospital.hospitalCodeLabel": "병원 코드",
        "admin.addHospital.hospitalCodePlaceholder": "ABC(알파벳 3자리)",
        "admin.addHospital.cancelButton": "취소",
        "admin.addHospital.submitButton": "등록하기",
        "admin.addHospital.hospitalNameRequired": "병원 전체 이름을 입력해주세요.",
        "admin.addHospital.hospitalNameMinLength": "병원 전체 이름은 2자리 이상 입력해주세요.",
        "admin.addHospital.hospitalNameFormat": "병원 이름은 한글, 영문, 숫자, 공백만 입력 가능합니다.",
        "admin.addHospital.hospitalCodeRequired": "병원 코드를 입력해주세요.",
        "admin.addHospital.hospitalCodeFormat": "병원 코드는 알파벳 3자리로 입력해주세요.",

        "admin.home.hospitalList": "병원 목록",
        "admin.home.notice": "공지사항",
        "notice.title": "공지사항",
        "notice.delete": "삭제",
        "notice.create": "작성하기",
        "notice.searchPlaceholder": "제목, 등록자, 빌드번호로 검색",
        "notice.noData": "공지사항 데이터가 없습니다.",
        "notice.table.title": "제목",
        "notice.table.author": "등록자",
        "notice.table.publishPeriod": "게시 기간",
        "notice.table.lastModified": "최근 수정 일시",
        "notice.table.buildNumber": "빌드 번호",
        "notice.table.edit": "수정하기",
        "notice.important": "중요",
        "notice.add.title": "작성하기",
        "notice.add.titleLabel": "제목",
        "notice.add.titlePlaceholder": "제목을 입력해주세요",
        "notice.add.publishPeriod": "게시 기간",
        "notice.add.buildNumber": "빌드 번호",
        "notice.add.content": "본문",
        "notice.add.contentPlaceholder": "내용을 입력해주세요",
        "notice.add.exposeAllVersions": "모든 버전에 노출하기",
        "notice.add.cancel": "취소",
        "notice.add.submit": "등록",
        "notice.edit.title": "수정하기",
        "notice.edit.cancel": "취소",
        "notice.edit.submit": "수정",
        "notice.edit.delete": "삭제",
        "notice.edit.notFound": "공지사항을 찾을 수 없습니다.",
        "notice.detail.title": "공지 상세",
        "notice.detail.author": "작성자",
        "notice.detail.publishPeriod": "게시 기간",
        "notice.detail.lastModified": "최근 수정 일시",
        "notice.detail.buildNumber": "빌드 번호",
        "notice.detail.edit": "수정하기",
        "notice.modal.deleteTitle": "공지사항 삭제",
        "notice.modal.deleteMessage": "선택된 {{count}}개의 게시글을 삭제하시겠습니까?",
        "notice.modal.deleteButton": "삭제",
        "notice.modal.cancelButton": "취소",
        "notice.modal.noNoticesToDelete": "삭제할 공지사항이 없습니다",
        "notice.toast.deleteSuccess": "{{count}}개의 공지사항을 삭제했습니다.",
        "notice.edit.successMessage": "공지사항 수정 성공",
        "notice.edit.cancelTitle": "작성 취소 확인",
        "notice.edit.cancelMessage": "작성을 취소하시겠습니까? \n 현재 입력한 내용이 저장되지 않고 사라집니다.",
        "notice.edit.cancelButton": "취소하기",
        "notice.edit.continueButton": "계속 작성하기",
        "notice.edit.deleteTitle": "게시글 삭제",
        "notice.edit.deleteMessage": "게시글을 삭제하시겠습니까?",
        "notice.edit.deleteButton": "삭제하기",
        "notice.edit.deleteSuccessMessage": "공지사항 삭제 성공",
        "notice.add.successMessage": "공지사항 등록 성공",
        "component.sectionGroup.registerAsImportantNotice": "중요 공지로 등록하기",
        "pagination.itemsPerPage": "페이지당 항목 수",
        "pagination.page": "페이지",
        "pagination.of": "중",
        "pagination.total": "총",
        "pagination.items": "개 항목",
        "log.table.occurredAt": "발생시각",
        "log.table.type": "타입",
        "log.table.event": "이벤트",
        "log.table.user": "유저",
        "log.table.targetUser": "타겟유저",
        "log.table.activityDetails": "활동내역",
        "log.noData": "로그 데이터가 없습니다.",
        "log.noFilteredData": "필터링된 로그 데이터가 없습니다.",
        "log.searchPlaceholder": "ID",
        "log.copiedMessage": "값이 복사되었습니다.",
        "log.modal.okButton": "확인",
        "actionLog.tabs.all": "전체",
        "actionLog.table.occurredAt": "발생시각",
        "actionLog.table.eventType": "타입",
        "actionLog.table.eventAction": "액션",
        "actionLog.table.component": "컴포넌트",
        "actionLog.table.parameter": "파라미터",
        "actionLog.table.pageScene": "페이지",
        "actionLog.noData": "액션 로그 데이터가 없습니다.",
        "actionLog.searchRequired": "스크리닝 ID를 검색해주세요.",
        "actionLog.searchPlaceholder": "스크리닝 ID",
        "header.admin": "관리자",
        "hospital.table.hospitalName": "병원 이름",
        "hospital.table.hospitalCode": "병원 코드",
        "hospital.table.doctorCount": "등록 의료진 수",
        "hospital.table.patientCount": "등록 환자 수",
        "hospital.delete": "삭제",
        "hospital.register": "등록하기",
        "hospital.searchPlaceholder": "병원명 또는 코드로 검색",
        "hospital.noData": "병원 데이터가 없습니다.",
        "hospital.noSearchResults": "검색 결과가 없습니다.",
        "hospital.noSearchResultsWithQuery": "\"{{query}}\" 로 검색된 항목이 없습니다.",
        "hospital.disabledMessage.hasDoctorsAndPatients": "등록된 의사와 환자가 있어 선택할 수 없습니다",
        "hospital.disabledMessage.hasDoctors": "등록된 의사가 있어 선택할 수 없습니다",
        "hospital.disabledMessage.hasPatients": "등록된 환자가 있어 선택할 수 없습니다",
        "admin.home.logs": "로그 조회",
        "admin.home.actionLogs": "액션 로그",
        "admin.home.addDoctor.line1": "의료진을 등록",
        "admin.home.addDoctor.line1-1": "하거나",
        "admin.home.addDoctor.line2": "조회",
        "admin.home.addDoctor.line2-1": "하세요",
        "admin.home.addDoctorButton": "의료진 등록하기",
        "admin.home.doctorListButton": "의료진 목록 조회",
        "admin.home.searchPatient.line1": "등록된 환자 정보",
        "admin.home.searchPatient.line1-1": "를",
        "admin.home.searchPatient.line2": "확인하세요",
        "admin.home.patientListButton": "환자 목록 조회",
        "toast.addPatient.successMessage": "신규 환자가 등록되었습니다.",
        "toast.addDoctor.successMessage": "의료진이 성공적으로 등록되었습니다.",
        "toast.addHospital.successMessage": "병원이 성공적으로 등록되었습니다.",
        "toast.deleteHospital.successMessage": "병원이 정상적으로 삭제되었습니다.",
        "toast.addPrescription.successMessage": "치료 기간이 설정되었습니다.",
        "toast.terminateTreatment.successMessage": "치료가 중단되었습니다.",
        "toast.patient.inactive.successMessage": "환자가 비활성화 되었습니다.",
        "toast.doctor.inactive.successMessage": "의사가 비활성화 되었습니다.",
        "toast.doctor.active.successMessage": "의사가 활성화 되었습니다.",
        "toast.patient.active.successMessage": "환자가 활성화 되었습니다.",
        "initPassword.title": "초기 패스워드 설정",
        "initPassword.newPasswordPlaceholder": "초기 패스워드를 입력해주세요",
        "initPassword.confirmPasswordPlaceholder": "패스워드를 재입력해주세요",
        "initPassword.processing": "처리중...",
        "initPassword.setPasswordButton": "패스워드 설정",
        "admin.doctorDetail.doctorNameRequired": "의료진 이름을 입력해주세요.",
        "admin.doctorDetail.hospitalRequired": "병원을 선택해주세요.",
        "admin.doctorDetail.updateSuccessMessage": "의료진 정보가 수정되었습니다",
        "admin.doctorDetail.passwordResetSuccessMessage": "비밀번호 설정 메시지 재전송 완료",
        "admin.doctorDetail.sendPasswordResetButton": "비밀번호 설정 메시지 재전송",

        "operationLog.tabs.all": "전체",
        "operationLog.tabs.doctor": "의료진",
        "operationLog.tabs.patient": "환자",
        "operationLog.tabs.admin": "관리자",
        "operationLog.tabs.treatment": "치료",
        "medicalDevice.title": "의료기기 정보",
        "medicalDevice.section1.title": "1. 제품 정보",
        "medicalDevice.section1.manufacturingNumber": "제조번호/제조연월",
        "medicalDevice.section1.manufacturingNumber.value": "• 제조번호 : SAT00120260930\n• 제조연월 : 2026.09.30",
        "medicalDevice.section1.manufacturerName": "제조자 상호",
        "medicalDevice.section1.manufacturerName.value": "(주) 에스알파테라퓨틱스",
        "medicalDevice.section1.manufacturerAddress": "제조자 주소",
        "medicalDevice.section1.manufacturerAddress.value": "서울특별시 영등포구 양산로 91, 608호",
        "medicalDevice.section1.manufacturerContact": "제조사 연락처",
        "medicalDevice.section1.manufacturerContact.value": "02-3487-3923",
        "medicalDevice.section1.licenseNumber": "인증번호(허가번호)",
        "medicalDevice.section1.licenseNumber.value": "• 디지털의료기기 제조 인증번호 : D 제인 26-4035 호\n• 업허가번호 : D 제 10090 호",
        "medicalDevice.section1.productName": "제품명",
        "medicalDevice.section1.productName.value": "MyoHabit™",
        "medicalDevice.section1.productVersion": "제품 버전",
        "medicalDevice.section1.productVersion.value": "v1.0.0(1)",
        "medicalDevice.section1.udi": "의료기기 표준코드 (UDI)",
        "medicalDevice.section1.udi.value": "GTIN (UDI-DI) : (01) 8800404790000\nSW-Version (UDI-PI) : (10) V1.0.0",
        "medicalDevice.section1.networkRequired": "네트워크 필요여부",
        "medicalDevice.section1.networkRequired.value": "• 본 제품은 정상적인 사용을 위해 지속적인 인터넷 연결이 필요합니다.\n• 권장 네트워크 환경: 안정적인 유선 또는 고속 무선 인터넷 (최소 업로드/다운로드 속도 5Mbps 이상)\n• 병원 내 방화벽, 보안 장비 등으로 인한 외부 서버 접속 제한 시, 기능이 정상적으로 작동하지 않을 수 있습니다.",
        "medicalDevice.section1.minimumSpecs": "지원기기 최소 사양",
        "medicalDevice.section1.minimumSpecs.value": "OS\n• Windows 10 이상\n• macOS Monterey 이상\n\nCPU\n• Intel Core i3 이상\n• AMD Ryzen 3 이상\n\nRAM\n• 4GB 이상",
        "medicalDevice.section1.supportedBrowsers": "지원 브라우저",
        "medicalDevice.section1.supportedBrowsers.value": "• latest 2 Chrome version\n• latest 2 Edge version",
        "medicalDevice.section1.customerSupport": "고객지원센터 정보",
        "medicalDevice.section1.customerSupport.value": "02-3487-3923",
        "medicalDevice.section2.title": "2. 사용자용 표시 정보",
        "medicalDevice.section2.productDescription": "제품 설명",
        "medicalDevice.section2.productDescription.value": "본 제품은 소아 근시 진행 억제를 위한 디지털 의료기기의 처방 관리에 사용되는 전문가용, 디지털의료기기소프트웨어입니다.",
        "medicalDevice.section2.productDescription.highlight": "디지털의료기기소프트웨어",
        "medicalDevice.section2.usagePurpose": "사용 목적",
        "medicalDevice.section2.usagePurpose.value": "안과 의료진을 대상으로, 의료기관에서 근시를 진단받은 환자에게 근시 진행 억제 치료 프로그램의 사용 권한을 부여하고, 진행 현황을 모니터링 할 수 있도록 설계된 소프트웨어입니다.\n\n클라우드 기반 서버와 통신하며, 웹 기반 UI를 통해 의료진이 접근하도록 구성되었습니다.",
        "medicalDevice.section2.usageMethod": "사용 방법",
        "medicalDevice.section2.usageMethod.value": "사용자 매뉴얼 참고",
        "medicalDevice.section2.contraindications": "금기 사항 및 예상 부작용",
        "medicalDevice.section2.contraindications.value": "임상시험 결과 본 제품과 관련된 부작용은 보고되지 않았습니다.",
        "medicalDevice.section2.warnings": "경고 문구",
        "medicalDevice.section2.warnings.value": "• 본 제품은 사용 환경(예. 네트워크 연결 상태, 기기 성능 등)에 따라 작동 지연, 기능 오류 또는 예기치 않은 종료 현상이 발생할 수 있습니다. 안정적인 네트워크 환경에서 권장 사양 이상의 기기를 사용하십시오.\n• 공용 또는 등록되지 않은 네트워크(Wi-Fi 등)의 사용을 자제하여 주십시오.\n• 환자 및 보호자 정보 유출에 주의하여 주십시오.\n• 보안 관련 문제 발생 시 고객 지원 센터로 연락하여 주십시오.\n• 의료진 계정 정보를 타인과 공유하지 마십시오.\n• 사용 후 반드시 로그아웃하십시오.\n• 제품 내 치료 관련 데이터 입력 시 정확하게 입력하였는지 다시 한번 확인해주십시오.\n• 기재된 사용목적 이외의 용도로 사용하지 마십시오.",
        "medicalDevice.section3.title": "3. 사이버보안 관련 안내 사항",
        "medicalDevice.section3.link": "사이버보안 사고 안내",
        "medicalDevice.section4.title": "4. 사용 시 주의사항",
        "medicalDevice.section4.link": "MyoHabit™ 사용 시 주의 사항",
        "medicalDevice.note.label": "참고",
        "medicalDevice.note.value": "본 웹 시스템은 디지털 치료기기 앱의 처방 관리 목적으로만 사용되며, 직접적인 치료 행위는 연동된 환자용앱에서 수행됩니다.",
        "medicalDevice.table.header.item": "항목",
        "medicalDevice.table.header.content": "내용",
        "errorBoundary.title": "오류가 발생했습니다",
        "errorBoundary.message": "페이지를 불러오는 중 문제가 발생했습니다.",
        "errorBoundary.reload": "새로고침",
        "initialModuleLoad.failureTitle": "초기 모듈 로딩 실패",
        "initialModuleLoad.failureDescription": "안정적인 서비스를 위해 새로고침이 필요합니다.",
        "unknownError.title": "알 수 없는 오류",
        "unknownError.description": "잠시 후 다시 시도해주세요",
        "eventHubUnavailable.emailTitle": "Email 발송 실패",
        "eventHubUnavailable.emailDescription": "일시적인 서비스 오류로 메일이 발송되지 않았습니다. 문제가 계속되면 고객센터로 문의해 주세요.",
        "eventHubUnavailable.smsTitle": "SMS 발송 실패",
        "eventHubUnavailable.smsDescription": "일시적인 서비스 오류로 메시지가 발송되지 않았습니다. 문제가 계속되면 고객센터로 문의해 주세요.",
      },
    },
    en: {
      translation: {
        "selfSignup.patient.title": "Please enter child information to use the {{PRODUCT_NAME}} app.",
        "selfSignup.patient.childName": "Child Name",
        "selfSignup.patient.placeholderChildName": "Enter child name",
        "selfSignup.patient.gender": "Gender",
        "selfSignup.patient.birthDate": "Birth Date",
        "selfSignup.summary.confirm": "Do you want to register the patient with the entered child information?",
        "selfSignup.summary.childName": "Child Name",
        "selfSignup.summary.gender": "Gender",
        "selfSignup.summary.birthDate": "Birth Date",
        "selfSignup.summary.guardianName": "Guardian Name",
        "selfSignup.summary.guardianPhone": "Guardian Phone Number",
        "selfSignup.summary.guardianEmail": "Guardian Email",
        "selfSignup.summary.submit": "Register patient with the above information",
        "selfSignup.guardian.title": "Please enter guardian information to use the {{PRODUCT_NAME}} app.",
        "selfSignup.guardian.name": "Guardian Name",
        "selfSignup.guardian.placeholderName": "Enter guardian name",
        "selfSignup.guardian.phone": "Guardian Phone Number",
        "selfSignup.guardian.authCompleted": "Authentication completed",
        "selfSignup.guardian.authCode": "Authentication Code",
        "selfSignup.guardian.emailOptional": "Guardian Email (Optional)",
        "selfSignup.cancel.title": "Registration has been cancelled.",
        "selfSignup.cancel.description": "Please close the screen.",
        "selfSignup.complete.title": "Patient registration request completed!",
        "selfSignup.complete.description1": "After approval by the medical staff, an account creation link will be sent to the phone number you entered.",
        "selfSignup.complete.description2": "You can use the treatment program by creating an account through the link.",
        "selfSignup.complete.note": "※ If you don't receive a text message, please check your spam filter.",
        "selfSignup.bottomSheet.dataError.title": "Data Error",
        "selfSignup.bottomSheet.dataError.description": "Required data for the bottom sheet is missing.",
        "selfSignup.bottomSheet.dataError.errorType": "Error Type",
        "selfSignup.bottomSheet.dataError.missingFields": "Missing Fields",
        "selfSignup.bottomSheet.dataError.developerNote": "Developer Note: Please pass the correct data for each error type.",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.title": "Already Registered Guardian",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.description": "A guardian is already registered with this phone number.",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.detailInfo": "Registered Patient: ({{patientName}})",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.okButton": "OK",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.cancelButton": "Cancel",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.title": "Already Registered Patient",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.description": "A patient is already registered with this information.",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.patientNameGender": "Name/Gender",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.birthDate": "Birth Date",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.guardianName": "Guardian Name",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.guardianPhoneNumber": "Guardian Phone Number",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.guardianEmail": "Guardian Email",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.okButton": "OK",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.cancelButton": "Cancel",
        "selfSignup.bottomSheet.alreadyReadySignup.title": "Patient Registration Pending",
        "selfSignup.bottomSheet.alreadyReadySignup.description": "A registration request is already in progress with this information.",
        "selfSignup.bottomSheet.alreadyReadySignup.patientNameGender": "Name/Gender",
        "selfSignup.bottomSheet.alreadyReadySignup.birthDate": "Birth Date",
        "selfSignup.bottomSheet.alreadyReadySignup.guardianName": "Guardian Name",
        "selfSignup.bottomSheet.alreadyReadySignup.guardianPhoneNumber": "Guardian Phone Number",
        "selfSignup.bottomSheet.alreadyReadySignup.guardianEmail": "Guardian Email",
        "selfSignup.bottomSheet.alreadyReadySignup.okButton": "OK",
        "selfSignup.bottomSheet.alreadyReadySignup.cancelButton": "Cancel",
        "common.close": "Close",
        "common.errorCode": "(Error Code : {{code}})",
        "common.patient": "Patient",
        "common.day": "Day",
        "common.previous": "Previous",
        "common.next": "Next",
        "common.count": "Count",
        "common.times": "times",
        "common.coordinate": "Coordinate",
        "common.xCoordinate": "X Coordinate",
        "common.yCoordinate": "Y Coordinate",
        "common.eyePosition": "Movement Count",
        "common.loadingChart": "Loading chart...",
        "common.dayProgress": "(Day {{day}})",
        "activityChart.chartDescription": "This graph visualizes the eye movement coordinates measured in real-time while the patient performs treatment activities.",
        "activityChart.xAxisHint": "(Left-Right)",
        "activityChart.yAxisHint": "(Up-Down)",
        "activityChart.timeLabel": "Time (seconds)",
        "activityChart.gazePosition": "Gaze Position",
        "activityChart.gazePositionX": "Gaze Position (X-axis)",
        "activityChart.gazePositionY": "Gaze Position (Y-axis)",
        "common.addPatient": "Add Patient",
        "common.toast.patientPending": "Patient is pending registration.",
        "common.toast.registerButton": "Register",
        "common.toast.unknownError": "An unknown error occurred.",
        "common.auth.sendCode": "Send Verification Code",
        "common.auth.resendCode": "Resend Verification Code",
        "selfSignup.header.title": "Child Registration",
        "selfSignup.welcome.greeting": "Hello.",
        "selfSignup.welcome.hospitalSuffix": " Hospital.",
        "selfSignup.welcome.needRegistrationLine1": "To start SAT001",
        "selfSignup.welcome.needRegistrationLine2": "child registration is required.",
        "selfSignup.welcome.privacyNotice": "Personal information collected during verification is not used for other purposes.",
        "selfSignup.welcome.startRegistration": "Start Registration",
        "selfSignup.notAllowed.title": "Access Restricted",
        "selfSignup.notAllowed.message": "The hospital code is not approved.",
        "selfSignup.notAllowed.description": "Please try again with a valid hospital code.",
        "appAccount.checkName.description": "Please verify your identity\n to set the {{APP_PRODUCT_NAME}} ID and password.",
        "appAccount.checkName.guardianName": "Guardian Name",
        "appAccount.checkName.placeholderGuardianName": "Enter name",
        "appAccount.common.checking": "Checking...",
        "appAccount.complete.title": "Account setup complete.",
        "appAccount.complete.description": "You can start {{APP_PRODUCT_NAME}} with the configured account.",
        "appAccount.complete.hint": "Press the Login button below to start {{APP_PRODUCT_NAME}}.",
        "appAccount.complete.login": "Login",
        "appAccount.expired.title": "Account setup link has expired.",
        "appAccount.expired.beforeSetup": "If you are <point>before setup</point>, ask your hospital to resend the setup message.",
        "appAccount.expired.afterSetup": "If you have <point>completed setup</point>, start {{APP_PRODUCT_NAME}}.",
        "appAccount.common.next": "Next",
        "appAccount.common.userId": "User ID",
        "appAccount.common.password": "Password",
        "appAccount.setupAccount.description": "Set your {{APP_PRODUCT_NAME}} ID and password.",
        "appAccount.setupAccount.placeholderUserId": "Enter your user ID",
        "appAccount.setupAccount.placeholderPassword": "Enter your password",
        "appAccount.setupAccount.passwordConfirm": "Confirm Password",
        "appAccount.setupAccount.placeholderPasswordConfirm": "Re-enter new password",
        "findPassword.requestComplete.title": "Email Sent",
        "findPassword.requestComplete.sentTo": "Password reset email sent to",
        "findPassword.requestComplete.setNewPassword": "Please set a new password.",
        "findPassword.requestComplete.checkSpam": "If you don't see the email, check your spam folder.",
        "findPassword.token.title": "Reset Password",
        "findPassword.token.placeholderNewPassword": "Enter new password",
        "findPassword.token.placeholderConfirmPassword": "Re-enter new password",
        "findPassword.token.submit": "Change Password",
        "findPassword.codeValidation.title": "Enter password reset code",
        "findPassword.codeValidation.description": " Please enter the password reset code sent to ",
        "findPassword.common.next": "Next",
        "findPassword.requestLink.title": "Find Password",
        "findPassword.requestLink.description": "Enter the email to receive a password reset code.",
        "findPassword.requestLink.placeholderEmail": "Enter your email",

        "findPassword.viewModel.error.title": "Error Occurred",
        "findPassword.viewModel.error.description": "An unknown error occurred. Please try again later.",
        "findPassword.viewModel.error.confirm": "Confirm",
        "findPassword.viewModel.invalidToken.title": "Invalid Token",
        "findPassword.viewModel.invalidToken.description": "The password reset link is invalid. Redirecting to login screen.",
        "findPassword.viewModel.passwordMismatch": "Passwords do not match.",
        "findPassword.viewModel.passwordChangeComplete.title": "Password Change Complete",
        "findPassword.viewModel.passwordChangeComplete.description": "Password change completed. Redirecting to login screen.",
        "findPassword.viewModel.passwordValidation.length": "8-20 characters",
        "findPassword.viewModel.passwordValidation.letter": "Include English letters",
        "findPassword.viewModel.passwordValidation.number": "Include numbers",
        "findPassword.viewModel.passwordValidation.special": "Include special characters (!@#$%^&*)",
        "findPassword.viewModel.console.emailChange": "Clear existing error message when email changes",
        "common.ok": "OK",
        "common.timeZoneDetection.title": "Time Tampering Detected",
        "common.timeZoneDetection.description": "Time tampering was detected. Please check that your current time setting is correct and sign in again.",
        "common.agree": "Agree",
        "common.gender.male": "Male",
        "common.gender.female": "Female",
        "common.date.format": "{{month}}/{{day}}/{{year}}",
        "common.activity.LeftRightRail": "Left-Right Rail",
        "common.activity.Rotation": "Rotation",
        "common.activity.UpDown": "Up-Down",
        "common.activity.FourWay": "Four-Way",
        "common.activity.LeftRightRepeat": "Left-Right Repeat",
        "common.activityState.notStarted": "Not Started",
        "common.activityState.inProgress": "In Progress",
        "common.activityState.completed": "Completed",

        "footer.medical.device.info": "Medical Device Information",
        "footer.terms": "Terms of Service",
        "footer.privacy": "Privacy Policy",
        "footer.language": "English",

        "language.ko": "한국어",
        "language.en": "English",
        "language.ja": "日本語",
        "footer.console.excludePath": "Footer not displayed as it is included in EXCLUDE_FOOTER_PATH.",

        "login.email": "Email",
        "login.password": "Password",
        "login.forgotPassword": "Find password",
        "login.signIn": "Sign in",
        "login.signUp": "Sign up",
        "login.warning.registeredUsersOnly": "This system is accessible only to registered users.",
        "login.warning.monitoringAndRecording": "System usage is subject to monitoring and recording, and unauthorized use may result in civil and criminal penalties.",
        "login.warning.loginAgreement": "Logging in means you agree to the terms of use.",
        "login.remember": "Save email",
        "login.error": "Login failed. Please try again.",
        "login.browserWarning.title": "We recommend using a different browser",
        "login.browserWarning.description": "Some features may be limited in your current browser. We recommend using Chrome or Edge browser. Please use Chrome or Edge browser to use the system.",
        "login.browserWarning.okButton": "OK",
        "common.loading": "Loading...",
        "common.processing": "Processing...",

        "home.searchBarPlaceholder": "Search by patient name.",
        "home.titleAddNewPatient": "<b>Register a new patient</b>",
        "home.addPatientByQR": "QR code registration",
        "home.addPatientByDoctor": "Add Patient",
        "home.titleAddNewPrescription": "<b>Check the registered patient</b> and <br /> <b>add treatment</b>.",
        "home.inProgressPatient": "In progress patient",
        "home.personCountUnit": "people",
        "home.showPatientList": "View patient list",
        "home.searchHelp": "Enter the patient's name to search",
        "home.actionLogs": "Action Logs",

        "patientList.patientNumber": "Code",
        "patientList.title": "Patient List",
        "patientList.name": "Name",
        "patientList.deactive": "Deactive",
        "patientList.birthDay": "Birthday",
        "patientList.progress": "Treatment(Stage/Status/Adherence)",
        "patientList.memo": "Memo",
        "patientList.info": "Patient Info",
        "patientList.filterPrescriptionAdd": "Show patients with prescription registration",
        "patientList.filterByName": "Search by name",
        "patientList.doctor": "Doctor",
        "patientList.emptyPatient": "No registered patients",
        "patientList.emptyPatientWithAddPrescriptionAvailable": "No patients available for treatment registration.",
        "patientList.emptyFilteredPatient": "No search results",
        "patientList.emptyFilteredPatientWithName": "Register a patient named '<strong>{{name}}</strong>'",
        "patientList.stepVisit": "Visit {{step}}",
        "patientList.progressInfo.inProgress": "In progress",
        "patientList.progressInfo.completed": "Completed",
        "patientList.progressInfo.notStarted": "Not Started",
        "patientList.progressInfo.interrupted": "Interrupted",
        "patientList.progressInfo.canceled": "Canceled",
        "patientList.progressInfo.noActivityStepsInProgress": "No activity steps in progress",
        "patientList.progressInfo.beforeStart": "Before start",
        "patientList.addTreatmentBt": "Set Treatment",
        "patientList.birthdayWithAge": "{{date}}/Age {{age}}",

        "addTreatment.title": "Treatment Registration",
        "addTreatment.patientInfo": "Patient Info",
        "addTreatment.patientNameGender": "Name/Gender",
        "addTreatment.birthDate": "Birth Date",
        "addTreatment.treatmentInfo": "Treatment Info",
        "addTreatment.treatmentStep": "Treatment Step",
        "addTreatment.treatmentPeriod": "Treatment Period",
        "addTreatment.hospitalVisitDate": "Hospital Visit Date",
        "addTreatment.hospitalVisitDescription": ": Please visit the hospital to schedule the next step of your treatment.",
        "addTreatment.memo": "Memo",
        "addTreatment.memoPlaceholder": "Enter any special notes or comments",
        "addTreatment.cancel": "Cancel",
        "addTreatment.submit": "Set Treatment Period",
        "addTreatment.treatmentStepUnit": "Treatment Step",
        "addTreatment.week14": "14 weeks",
        "addTreatment.error.title": "Treatment Registration Failed",
        "addTreatment.error.description": "Treatment registration failed.",

        "patientTreatmentInfoCard.title": "Treatment Status",
        "patientTreatmentInfoCard.editTreatmentDuration": "Set Treatment Period",
        "patientTreatmentInfoCard.noData": "No data",
        "patientTreatmentInfoCard.columns.treatmentStep": "Step",
        "patientTreatmentInfoCard.columns.period": "Period",
        "patientTreatmentInfoCard.columns.date": "Date",
        "patientTreatmentInfoCard.columns.state": "State",
        "patientTreatmentInfoCard.columns.activityTime": "Activity Time",
        "patientTreatmentInfoCard.columns.activityTimeSubHeader": "Performed Time (Recommended)",
        "patientTreatmentInfoCard.columns.adherence": "Adherence",
        "patientTreatmentInfoCard.columns.doctor": "Doctor",
        "patientTreatmentInfoCard.columns.dayLabel": "Day",
        "patientTreatmentInfoCard.summaryCard.inProgressTreatment": "Current Treatment Status",
        "patientTreatmentInfoCard.summaryCard.totalAdherence": "Total Adherence",
        "patientTreatmentInfoCard.stepUnit": "Step",
        "patientTreatmentInfoCard.units.step": "Step",
        "patientTreatmentInfoCard.units.day": "Day",
        "patientTreatmentInfoCard.units.minute": "Min",

        "patientDetail.error.title": "Patient Detail Loading Failed",
        "patientDetail.error.description": "Failed to load patient detail information. Please try again later.",
        "patientDetail.button.confirm": "Confirm",
        "patientDetail.emptyTreatmentCard.noTreatment": "No ongoing treatment",
        "patientDetail.deactivatedInfoLabel": "This patient is deactivated. Activate to add treatment or edit info.",
        "patientDetail.activate": "Activate",
        "patientDetail.showChart": "Show Chart",
        "patientDetail.showDetail": "Details",
        "patientDetail.lightEstimation": "Bright Light Validation",

        "patientGuardianInputForm.guardianInfo": "Guardian Info",
        "patientGuardianInputForm.patientInfo": "Patient Info",
        "patientGuardianInputForm.patientName": "Patient Name",
        "patientGuardianInputForm.patientNamePlaceholder": "John Doe",
        "patientGuardianInputForm.patientBirthDate": "Patient Birth Date",
        "patientGuardianInputForm.patientGender": "Patient Gender",
        "patientGuardianInputForm.patientMemo": "Patient Memo",
        "patientGuardianInputForm.guardianName": "Guardian Name",
        "patientGuardianInputForm.guardianNamePlaceholder": "John Doe",
        "patientGuardianInputForm.guardianPhoneNumber": "Guardian Phone Number",
        "patientGuardianInputForm.guardianEmail": "Guardian Email",
        "patientGuardianInputForm.required": "Required",
        "patientGuardianInputForm.optional": "Optional",

        "breadcrumbs.home": "Home",
        "breadcrumbs.profile": "Profile Information",
        "breadcrumbs.patientList": "Patient List",
        "breadcrumbs.addPatient": "Add Patient",
        "breadcrumbs.patientDetail": "Patient Detail",
        "breadcrumbs.addTreatment": "Set Treatment Period",
        "breadcrumbs.treatmentProgress": "Treatment Progress",
        "breadcrumbs.medicalDeviceInfo": "Medical Device Information",
        "breadcrumbs.adminHome": "Admin Home",
        "breadcrumbs.adminDoctors": "Medical Staff Management",
        "breadcrumbs.doctorDetail": "Medical Staff Detail",
        "breadcrumbs.adminHospitals": "Hospitals List",
        "breadcrumbs.adminAddHospital": "Add Hospital",
        "breadcrumbs.adminPatients": "Patient List",
        "breadcrumbs.adminLogs": "Logs",
        "breadcrumbs.adminActionLogs": "Action Logs",
        "breadcrumbs.actionLogs": "Action Logs",
        "breadcrumbs.adminAddDoctor": "Add Medical Staff",
        "breadcrumbs.adminEditNotice": "Edit Notice",
        "breadcrumbs.adminAddNotice": "Add Notice",
        "breadcrumbs.adminNotices": "Notice List",
        "breadcrumbs.noticeDetail": "Notice Detail",
        "breadcrumbs.myInfo": "My Information",
        "breadcrumbs.passwordChange": "Change Password",

        "errorPage.defaultMessage": "An error occurred. Please try again later.",
        "errorPage.error": "Error",
        "errorPage.retry": "Retry",
        "errorPage.contact": "Contact: salpha@salphadtx.com",

        "phoneAuthCodeInput.placeholder": "Enter the 6-digit authentication code sent to your phone",

        "customDatepicker.dateSelection": "Select Date",
        "customDatepicker.cancel": "Cancel",
        "customDatepicker.select": "Select",

        "qrModal.hospitalName": "Hospital Name",
        "qrModal.scanQRCode": "Scan the QR code with your smartphone",
        "qrModal.useDefaultCamera": "Please use the default camera app",
        "qrModal.directRegistration": "Direct Patient Registration",
        "qrModal.complete": "Complete",
        "qrModal.close": "Close",

        "header.userManual": "View User Guide",
        "header.hospital": "Hospital",
        "header.changePassword": "Change Password",
        "header.logout": "Logout",
        "header.doctor": "Dr. {{doctorName}}",
        "header.console.registerAction": "Register",
        "header.console.logoutAction": "Executing default logout logic",

        "patientInfoCard.accountSetupMessageResend": "Resend Account Setup Message",
        "patientInfoCard.editInfo": "Edit Info",
        "patientInfoCard.editInfoButton": "Complete Setup",
        "patientInfoCard.patientNumber": "Patient Number",
        "patientInfoCard.guardianName": "Guardian Name",
        "patientInfoCard.guardianEmail": "Guardian Email",
        "patientInfoCard.guardianContact": "Guardian Contact",
        "patientInfoCard.memo": "Memo",
        "patientInfoCard.noMemo": "-",

        "component.loading.text": "Loading...",
        "component.dropdown.defaultPlaceholder": "Please enter a default value",
       "component.dropdown.arrow": "Arrow",
        "component.sectionGroup.deactivatePatient": "Deactivate Patient",
        "component.sectionGroup.deactivateDoctor": "Deactivate Account",
        "validation.email.required": "Please enter an email address.",
        "validation.email.invalidFormat": "Please enter a valid email address format.",
        "validation.password.required": "Please enter a password.",
        "validation.password.conditions": "Password does not meet the requirements.",
        "validation.password.changeComplete": "Password Change Complete",
        "validation.password.changeCompleteMessage": "Password change has been completed.",
        "password.change.initial.title": "Initial Password Change",
        "password.change.expired.title": "Expired Password Change",
        "password.change.default.title": "Password Change",
        "password.change.initial.description": "Please change your initial password for a more secure service.",
        "password.change.expired.description": "Please change to a new password every 6 months for a more secure service.",
        "password.change.default.description": "Please change to a new password.",
        "validation.userId.required": "Please enter a user ID.",
        "validation.userId.length": "6-16 characters",
        "validation.userId.format": "Only lowercase letters and numbers allowed",
        "validation.userId.duplicate": "This user ID is already in use.",
        "validation.password.confirmRequired": "Please enter password confirmation.",
        "validation.password.minimum": "Password must be at least 8 characters.",
        "validation.phone.invalidFormat": "Invalid phone number format.",
        "validation.phone.required": "Please enter a phone number.",
        "validation.phone.authRequired": "Please complete phone number verification.",
        "validation.phone.authInvalid": "Invalid verification code.",
        "validation.name.minimum": "Name must be at least 2 characters.",
        "validation.name.required": "Please enter a name.",
        "validation.name.noNumbers": "Numbers are not allowed in names.",
        "validation.name.noSpecialChars": "Special characters are not allowed in names.",
        "validation.name.allowedChars": "Only Korean, English letters, and spaces are allowed.",
        "validation.name.invalidFormat": "Please enter a valid name.",
        "notice.validation.titleEmpty": "Please enter a title",
        "notice.validation.contentEmpty": "Please enter content",
        "notice.validation.endDateBeforeStartDate": "If the end date is before the start date, please adjust the end date to the start date",
        "notice.validation.versionEmpty": "Please enter version",
        "notice.validation.errorTitle": "Notice Registration Error",
        "notice.validation.confirmButton": "Confirm",
        "validation.birthDate.required": "Please select a birth date.",
        "validation.guardianName.minimum": "Guardian name must be at least 2 characters.",
        "addTreatment.confirmEndCurrent": "Confirm End Current Treatment",
        "addTreatment.confirmEndCurrentDescription": "Do you want to end the current treatment and start a new one?",
        "patientDetail.updateFailed": "Patient Information Update Failed",
        "patientDetail.updateComplete": "Patient Information Update Complete",
        "patientDetail.updateCompleteMessage": "Patient information has been updated.",
        "patientDetail.deactivateTitle": "Deactivate Patient Account",
        "patientDetail.deactivateDescription": "The patient account will be deactivated. Ongoing treatments will be terminated, and you must reactivate to register new treatments.",
        "doctorDetail.deactivateTitle": "Deactivate Medical Staff Account",
        "doctorDetail.deactivateDescription": "The medical staff account will be deactivated. Login and all service access will be restricted, and reactivation will be required for reuse.",
        "doctorDetail.deactivatedInfoLabel": "This doctor is deactivated. Please reactivate to use login and information editing features.",
        "doctorDetail.activate": "Activate",
        "patientDetail.activateTitle": "Activate Patient Account",
        "patientDetail.activateDescription": "After activation, prescriptions will be available. Do you want to continue?",
        "errorPage.networkError": "Network Error Occurred",
        "patientInfoCard.accountSetupMessageSent": "Account creation guide message has been sent. Please check.",
        "selfSignup.registrationFailed": "Patient Registration Failed",
        "selfSignup.saveFailed": "Failed to save patient information. Please try again.",
        "selfSignup.saveFailedTitle": "Save Failed",
        "selfSignup.authCodeSendFailed": "Verification Code Send Failed",
        "addPatient.duplicatePatient": "Already Registered Patient Information",
        "addPatient.duplicatePatientDescription": "A patient with the same information is already registered. Duplicate registration is not possible. Please check the patient information you entered.",
        "addPatient.reEnter": "Re-enter",
        "addPatient.viewRegisteredPatient": "View Registered Patient Information",
        "addPatient.invalidGuardianPhoneNumberTitle": "Please check the guardian's phone number",
        "addPatient.invalidGuardianPhoneNumberDescription": "The phone number ({{guardianPhoneNumber}}) you entered is already registered as a guardian for another patient.",
        "addPatient.reInputGuardianPhoneNumber": "Please enter the correct phone number again",
        "common.cancel": "Cancel",
        "treatmentDetail.cancelComplete": "Treatment Cancellation Complete",
        "treatmentDetail.cancelCompleteMessage": "The current prescription has been successfully cancelled. Moving to patient information.",
        "treatmentDetail.confirmStop": "Confirm Treatment Cancellation",
        "treatmentDetail.confirmStopDescription": "Do you want to cancel the ongoing treatment?",
        "treatmentDetail.chartDataLoadFailed": "Treatment Chart Data Load Failed",
        "treatmentDetail.chartDataLoadFailedMessage": "Unable to load treatment chart data.",
        "findPassword.viewModel.authError": "Email, Authentication Error",
        "findPassword.viewModel.authErrorMessage": "An error occurred with email or authentication information. Please try again.",
        "validation.guardianName.required": "Please enter guardian name.",
        "validation.guardianName.mismatch": "Guardian name does not match.\nPlease enter the same guardian name registered at the hospital",
        "passwordChange.currentPasswordPlaceholder": "Enter current password",
        "passwordChange.newPasswordPlaceholder": "Enter new password",
        "passwordChange.confirmPasswordPlaceholder": "Re-enter new password",
        "passwordChange.changeButton": "Change Password",
        "treatmentDetail.summaryTitle": "{{step}}th Treatment Summary",
        "treatmentDetail.progressTitle": "{{step}}th Treatment Progress",
        "treatmentDetail.noProgressData": "No progress data available.",
        "treatmentDetail.memoPlaceholder": "Enter any special notes or comments.",
        "treatmentDetail.memoSave": "Save",
        "treatmentDetail.memoEdit": "Edit",
        "treatmentDetail.stopTreatment": "Stop Treatment",
        "errorPage.tryAgainLater": "Please try again later.",
        "test.newKey1": "New Translation Key 1",
        "test.newKey2": "New Translation Key 2",
        "test.newKey3": "New Translation Key 3",
        "admin.doctorList.title": "Doctor Management",
        "admin.doctorList.searchPlaceholder": "Name, Hospital Name",
        "admin.doctorList.nameHeader": "Doctor Name",
        "admin.doctorList.licenseHeader": "License Number",
        "admin.doctorList.hospitalHeader": "Hospital",
        "admin.doctorList.hospitalPhoneHeader": "Hospital Phone",
        "admin.doctorList.treatmentCountHeader": "Treatment Count",
        "admin.doctorList.emptySearchResult": "No search results found.",
        "admin.doctorList.emptyList": "No registered doctors.",
        "admin.doctorList.addDoctorPrompt": "Would you like to register this doctor?",
        "admin.doctorList.addDoctorButton": "Add Doctor",
        "admin.addDoctor.title": "Doctor Registration",
        "admin.addDoctor.doctorNameLabel": "Doctor Name",
        "admin.addDoctor.doctorNamePlaceholder": "John Doe",
        "admin.addDoctor.licenseNumberLabel": "License Number",
        "admin.addDoctor.licenseNumberPlaceholder": "01-123456",
        "admin.addDoctor.hospitalLabel": "Hospital",
        "admin.addDoctor.hospitalPlaceholder": "Enter hospital name",
        "admin.addDoctor.hospitalPhoneLabel": "Hospital Phone",
        "admin.addDoctor.hospitalPhonePlaceholder": "02-1234-5678",
        "admin.addDoctor.doctorEmailLabel": "Email",
        "admin.addDoctor.hospitalEmailLabel": "Hospital Email",
        "admin.addDoctor.emailPlaceholder": "salpha@salphadtx.com",
        "admin.addDoctor.memoLabel": "Memo",
        "admin.addDoctor.memoPlaceholder": "Enter notes or remarks",
        "admin.addDoctor.cancelButton": "Cancel",
        "admin.addDoctor.submitButton": "Register Doctor",
        "admin.addDoctor.successTitle": "Doctor Registration Complete",
        "admin.addDoctor.successMessage": "Doctor has been successfully registered.",
        "admin.addDoctor.doctorNameRequired": "Please enter doctor name.",
        "admin.addDoctor.licenseNumberRequired": "Please enter license number.",
        "admin.addDoctor.hospitalRequired": "Please enter hospital name.",
        "admin.addDoctor.selectHospital": "Select a hospital",
        "admin.addDoctor.addHospital": "Add Hospital",
        "admin.addDoctor.noHospitalFound": "No hospitals found",
        "admin.addDoctor.doctorEmailRequired": "Please enter email address.",
        "admin.addDoctor.hospitalPhoneInvalid": "Please enter a valid phone number format.",
        "admin.addDoctor.registrationFailed": "Doctor registration failed. Please try again.",
        "admin.doctorDetail.editInfo": "Edit Info",
        "admin.doctorDetail.editInfoButton": "Complete Setup",
        "admin.doctorDetail.editTitle": "Medical Staff Information Edit",
        "admin.doctorDetail.doctorNameLabel": "Medical Staff Name",
        "admin.doctorDetail.doctorNamePlaceholder": "Enter medical staff name",
        "admin.doctorDetail.hospitalNamePlaceholder": "Enter hospital name",
        "admin.doctorDetail.memoPlaceholder": "Enter memo",
        "admin.doctorDetail.doctorId": "Medical Staff ID",
        "admin.doctorDetail.email": "Email",
        "admin.doctorDetail.hospital": "Hospital",
        "admin.doctorDetail.memo": "Memo",
        "admin.doctorDetail.registeredTreatments": "{{ProductName}} Registered Treatments",
        "admin.doctorDetail.treatmentTable.createdAt": "Created At",
        "admin.doctorDetail.treatmentTable.patientId": "Patient ID",
        "admin.doctorDetail.treatmentTable.treatmentId": "Treatment ID",
        "admin.doctorDetail.treatmentTable.stepAndPeriod": "Step/Period",
        "admin.doctorDetail.treatmentTable.step": "Step",
        "admin.doctorDetail.treatmentTable.type": "Type",
        "admin.doctorDetail.treatmentTable.stepUnit": "th",
        "admin.doctorDetail.treatmentTable.weekUnit": "w",
        "admin.doctorDetail.treatmentTable.empty": "No registered treatments",
        "admin.doctorDetail.treatmentTable.cancelled": "Cancelled",
        "admin.doctorDetail.treatmentCountLabel": "Registered Treatments",
        "admin.doctorDetail.filter.all": "All",
        "admin.doctorDetail.filter.createdAt": "Created At",
        "admin.doctorDetail.filter.patientId": "Patient ID",
        "admin.doctorDetail.filter.treatmentId": "Treatment ID",
        "admin.doctorDetail.filter.placeholder.all": "Search by date, patient ID, treatment ID",
        "admin.doctorDetail.filter.placeholder.createdAt": "Enter date (e.g., 2024-01-01)",
        "admin.doctorDetail.filter.placeholder.patientId": "Enter patient ID",
        "admin.doctorDetail.filter.placeholder.treatmentId": "Enter treatment ID",
        "admin.addHospital.title": "Hospital Information",
        "admin.addHospital.hospitalNameLabel": "Hospital Name",
        "admin.addHospital.hospitalNamePlaceholder": "Enter full hospital name",
        "admin.addHospital.hospitalCodeLabel": "Hospital Code",
        "admin.addHospital.hospitalCodePlaceholder": "ABC (3 letters)",
        "admin.addHospital.cancelButton": "Cancel",
        "admin.addHospital.submitButton": "Register",
        "admin.addHospital.hospitalNameRequired": "Please enter full hospital name.",
        "admin.addHospital.hospitalNameMinLength": "Full hospital name must be at least 2 characters.",
        "admin.addHospital.hospitalNameFormat": "Hospital name can only contain Korean, English letters, numbers, and spaces.",
        "admin.addHospital.hospitalCodeRequired": "Please enter hospital code.",
        "admin.addHospital.hospitalCodeFormat": "Hospital code must be 3 English letters.",

        "admin.home.hospitalList": "Hospital List",
        "admin.home.notice": "Notices",
        "notice.title": "Notices",
        "notice.delete": "Delete",
        "notice.create": "Create",
        "notice.searchPlaceholder": "Search by title, author, build number",
        "notice.noData": "No notice data available.",
        "notice.table.title": "Title",
        "notice.table.author": "Author",
        "notice.table.publishPeriod": "Publish Period",
        "notice.table.lastModified": "Last Modified",
        "notice.table.buildNumber": "Build Number",
        "notice.table.edit": "Edit",
        "notice.important": "Important",
        "notice.add.title": "Create Notice",
        "notice.add.titleLabel": "Title",
        "notice.add.titlePlaceholder": "Please enter the title",
        "notice.add.publishPeriod": "Publish Period",
        "notice.add.buildNumber": "Build Number",
        "notice.add.content": "Content",
        "notice.add.contentPlaceholder": "Please enter the content",
        "notice.add.exposeAllVersions": "Expose to all versions",
        "notice.add.cancel": "Cancel",
        "notice.add.submit": "Submit",
        "notice.edit.title": "Edit Notice",
        "notice.edit.cancel": "Cancel",
        "notice.edit.submit": "Update",
        "notice.edit.delete": "Delete",
        "notice.edit.notFound": "Notice not found.",
        "notice.detail.title": "Notice Detail",
        "notice.detail.author": "Author",
        "notice.detail.publishPeriod": "Publish Period",
        "notice.detail.lastModified": "Last Modified",
        "notice.detail.buildNumber": "Build Number",
        "notice.detail.edit": "Edit",
        "notice.modal.deleteTitle": "Delete Notice",
        "notice.modal.deleteMessage": "Are you sure you want to delete {{count}} selected notices?",
        "notice.modal.deleteButton": "Delete",
        "notice.modal.cancelButton": "Cancel",
        "notice.modal.noNoticesToDelete": "No notices selected for deletion",
        "notice.toast.deleteSuccess": "Deleted {{count}} notices.",
        "notice.edit.successMessage": "Notice updated successfully",
        "notice.edit.cancelTitle": "Confirm Cancel Writing",
        "notice.edit.cancelMessage": "Are you sure you want to cancel writing? \n Your current input will not be saved and will be lost.",
        "notice.edit.cancelButton": "Cancel",
        "notice.edit.continueButton": "Continue Writing",
        "notice.edit.deleteTitle": "Delete Post",
        "notice.edit.deleteMessage": "Are you sure you want to delete this post?",
        "notice.edit.deleteButton": "Delete",
        "notice.edit.deleteSuccessMessage": "Notice deleted successfully",
        "notice.add.successMessage": "Notice created successfully",
        "component.sectionGroup.registerAsImportantNotice": "Register as Important Notice",
        "pagination.itemsPerPage": "Items per page",
        "pagination.page": "Page",
        "pagination.of": "of",
        "pagination.total": "Total",
        "pagination.items": "items",
        "log.table.occurredAt": "Occurred At",
        "log.table.type": "Type",
        "log.table.event": "Event",
        "log.table.user": "User",
        "log.table.targetUser": "Target User",
        "log.table.activityDetails": "Activity Details",
        "log.noData": "No log data available.",
        "log.noFilteredData": "No filtered log data available.",
        "log.searchPlaceholder": "ID",
        "log.copiedMessage": "value copied.",
        "log.modal.okButton": "OK",
        "actionLog.tabs.all": "All",
        "actionLog.table.occurredAt": "Occurred At",
        "actionLog.table.eventType": "Type",
        "actionLog.table.eventAction": "Action",
        "actionLog.table.component": "Component",
        "actionLog.table.parameter": "Parameter",
        "actionLog.table.pageScene": "Page",
        "actionLog.noData": "No action log data available.",
        "actionLog.searchRequired": "Search by screening ID.",
        "actionLog.searchPlaceholder": "Screening ID",
        "header.admin": "Administrator",
        "hospital.table.hospitalName": "Hospital Name",
        "hospital.table.hospitalCode": "Hospital Code",
        "hospital.table.doctorCount": "Registered Medical Staff",
        "hospital.table.patientCount": "Registered Patients",
        "hospital.delete": "Delete",
        "hospital.register": "Register",
        "hospital.searchPlaceholder": "Search by name or code",
        "hospital.noData": "No hospital data available.",
        "hospital.noSearchResults": "No search results.",
        "hospital.noSearchResultsWithQuery": "No items found for \"{{query}}\".",
        "hospital.disabledMessage.hasDoctorsAndPatients": "Cannot select due to registered doctors and patients",
        "hospital.disabledMessage.hasDoctors": "Cannot select due to registered doctors",
        "hospital.disabledMessage.hasPatients": "Cannot select due to registered patients",
        "admin.home.logs": "Logs",
        "admin.home.actionLogs": "Action Logs",
        "admin.home.addDoctor.line1": "Register a doctor",
        "admin.home.addDoctor.line1-1": " or",
        "admin.home.addDoctor.line2": "View list",
        "admin.home.addDoctor.line2-1": "",
        "admin.home.addDoctorButton": "Register Doctor",
        "admin.home.doctorListButton": "View Doctor List",
        "admin.home.searchPatient.line1": "Registered patient info",
        "admin.home.searchPatient.line1-1": "",
        "admin.home.searchPatient.line2": "Check it",
        "admin.home.patientListButton": "View Patient List",
        "toast.addPatient.successMessage": "Patient has been successfully registered.",
        "toast.addDoctor.successMessage": "Doctor has been successfully registered.",
        "toast.addHospital.successMessage": "Hospital has been successfully registered.",
        "toast.deleteHospital.successMessage": "Hospital has been successfully deleted.",
        "toast.addPrescription.successMessage": "Treatment period has been set.",
        "toast.terminateTreatment.successMessage": "Treatment has been terminated.",
        "toast.patient.inactive.successMessage": "Patient has been deactivated.",
        "toast.doctor.inactive.successMessage": "Doctor has been deactivated.",
        "toast.doctor.active.successMessage": "Doctor has been activated.",
        "toast.patient.active.successMessage": "Patient has been activated.",
        "initPassword.title": "Initial Password Setup",
        "initPassword.newPasswordPlaceholder": "Please enter initial password",
        "initPassword.confirmPasswordPlaceholder": "Please re-enter new password",
        "initPassword.processing": "Processing...",
        "initPassword.setPasswordButton": "Set Password",
        "admin.doctorDetail.doctorNameRequired": "Please enter medical staff name.",
        "admin.doctorDetail.hospitalRequired": "Please select a hospital.",
        "admin.doctorDetail.updateSuccessMessage": "Medical staff information has been updated",
        "admin.doctorDetail.passwordResetSuccessMessage": "Password setup message resend completed",
        "admin.doctorDetail.sendPasswordResetButton": "Resend Password Setup Message",

        "operationLog.tabs.all": "All",
        "operationLog.tabs.doctor": "Doctor",
        "operationLog.tabs.patient": "Patient",
        "operationLog.tabs.admin": "Admin",
        "operationLog.tabs.treatment": "Treatment",
        "medicalDevice.title": "Medical Device Information",
        "medicalDevice.section1.title": "1. Product Information",
        "medicalDevice.section1.manufacturingNumber": "Manufacturing Number/Month",
        "medicalDevice.section1.manufacturingNumber.value": "• Manufacturing Number : SAT00120260930\n• Manufacturing Date : 2026.09.30",
        "medicalDevice.section1.manufacturerName": "Manufacturer Name",
        "medicalDevice.section1.manufacturerName.value": "S-Alpha Therapeutics Co., Ltd.",
        "medicalDevice.section1.manufacturerAddress": "Manufacturer Address",
        "medicalDevice.section1.manufacturerAddress.value": "Room 608, 91 Yangsan-ro, Yeongdeungpo-gu, Seoul",
        "medicalDevice.section1.manufacturerContact": "Manufacturer Contact",
        "medicalDevice.section1.manufacturerContact.value": "02-3487-3923",
        "medicalDevice.section1.licenseNumber": "License Number (Approval Number)",
        "medicalDevice.section1.licenseNumber.value": "• Digital Medical Device Manufacturing Certification Number : D Manufacturing Certification No. 26-4035\n• Business License Number : D Business License No. 10090",
        "medicalDevice.section1.productName": "Product Name",
        "medicalDevice.section1.productName.value": "MyoHabit™",
        "medicalDevice.section1.productVersion": "Product Version",
        "medicalDevice.section1.productVersion.value": "v1.0.0(1)",
        "medicalDevice.section1.udi": "Medical Device Standard Code (UDI)",
        "medicalDevice.section1.udi.value": "GTIN (UDI-DI) : (01) 8800404790000\nSW-Version (UDI-PI) : (10) V1.0.0",
        "medicalDevice.section1.networkRequired": "Network Requirement",
        "medicalDevice.section1.networkRequired.value": "• This product requires continuous internet connection for normal use.\n• Recommended network environment: Stable wired or high-speed wireless internet (minimum upload/download speed of 5Mbps or higher)\n• If external server access is restricted due to hospital firewalls, security equipment, etc., functions may not work properly.",
        "medicalDevice.section1.minimumSpecs": "Minimum Device Specifications",
        "medicalDevice.section1.minimumSpecs.value": "OS\n• Windows 10 or higher\n• macOS Monterey or higher\n\nCPU\n• Intel Core i3 or higher\n• AMD Ryzen 3 or higher\n\nRAM\n• 4GB or higher",
        "medicalDevice.section1.supportedBrowsers": "Supported Browsers",
        "medicalDevice.section1.supportedBrowsers.value": "• latest 2 Chrome version\n• latest 2 Edge version",
        "medicalDevice.section1.customerSupport": "Customer Support Information",
        "medicalDevice.section1.customerSupport.value": "02-3487-3923",
        "medicalDevice.section2.title": "2. User Display Information",
        "medicalDevice.section2.productDescription": "Product Description",
        "medicalDevice.section2.productDescription.value": "This product is a professional digital medical device software used for prescription management of digital medical devices for pediatric myopia progression inhibition.",
        "medicalDevice.section2.productDescription.highlight": "digital medical device software",
        "medicalDevice.section2.usagePurpose": "Usage Purpose",
        "medicalDevice.section2.usagePurpose.value": "This software is designed for ophthalmology medical staff to grant usage rights for myopia progression inhibition treatment programs to patients diagnosed with myopia at medical institutions and to monitor progress.\n\nIt communicates with cloud-based servers and is configured for medical staff to access through web-based UI.",
        "medicalDevice.section2.usageMethod": "Usage Method",
        "medicalDevice.section2.usageMethod.value": "Please refer to the user manual",
        "medicalDevice.section2.contraindications": "Contraindications and Expected Side Effects",
        "medicalDevice.section2.contraindications.value": "No side effects related to this product have been reported in clinical trials.",
        "medicalDevice.section2.warnings": "Warning",
        "medicalDevice.section2.warnings.value": "• This product may experience operational delays, functional errors, or unexpected termination depending on the usage environment (e.g., network connection status, device performance, etc.). Please use devices with recommended specifications or higher in a stable network environment.\n• Please refrain from using public or unregistered networks (Wi-Fi, etc.).\n• Please be careful about leakage of patient and guardian information.\n• Please contact the customer support center if security-related issues occur.\n• Do not share medical staff account information with others.\n• Please log out after use.\n• Please double-check that treatment-related data entered in the product is accurate.\n• Do not use for purposes other than the stated usage purpose.",
        "medicalDevice.section3.title": "3. Cybersecurity Information",
        "medicalDevice.section3.link": "Cybersecurity Incident Notification",
        "medicalDevice.section4.title": "4. Precautions for Use",
        "medicalDevice.section4.link": "Precautions for Using MyoHabit™",
        "medicalDevice.note.label": "Note",
        "medicalDevice.note.value": "This web system is used only for prescription management purposes of digital therapeutic device apps, and direct treatment activities are performed in the linked patient app.",
        "medicalDevice.table.header.item": "Item",
        "medicalDevice.table.header.content": "Content",
        "errorBoundary.title": "Something went wrong",
        "errorBoundary.message": "We had trouble loading this page.",
        "errorBoundary.reload": "Reload",
        "initialModuleLoad.failureTitle": "Initial Module Load Failed",
        "initialModuleLoad.failureDescription": "A refresh is required for stable service.",
        "unknownError.title": "Unknown Error",
        "unknownError.description": "Please try again in a moment.",
        "eventHubUnavailable.emailTitle": "Email Delivery Failed",
        "eventHubUnavailable.emailDescription": "The email could not be sent due to a temporary service error. If the problem continues, please contact customer support.",
        "eventHubUnavailable.smsTitle": "SMS Delivery Failed",
        "eventHubUnavailable.smsDescription": "The message could not be sent due to a temporary service error. If the problem continues, please contact customer support.",
      },
    },
    ja: {
      translation: {
        "selfSignup.patient.title": "{{PRODUCT_NAME}} アプリを利用するためにお子様の情報を入力してください。",
        "selfSignup.patient.childName": "患者名",
        "selfSignup.patient.placeholderChildName": "患者名を入力してください",
        "selfSignup.patient.gender": "性別",
        "selfSignup.patient.birthDate": "生年月日",
        "selfSignup.summary.confirm": "入力したお子様の情報で患者登録を進めますか？",
        "selfSignup.summary.childName": "お子様の名前",
        "selfSignup.summary.gender": "性別",
        "selfSignup.summary.birthDate": "生年月日",
        "selfSignup.summary.guardianName": "保護者の名前",
        "selfSignup.summary.guardianPhone": "保護者の電話番号",
        "selfSignup.summary.guardianEmail": "保護者メール",
        "selfSignup.summary.submit": "上記の内容で患者登録する",
        "selfSignup.guardian.title": "{{PRODUCT_NAME}} アプリを利用するために保護者の情報を入力してください。",
        "selfSignup.guardian.name": "保護者の名前",
        "selfSignup.guardian.placeholderName": "保護者の名前を入力してください",
        "selfSignup.guardian.phone": "保護者の電話番号",
        "selfSignup.guardian.authCompleted": "認証されました",
        "selfSignup.guardian.authCode": "認証コード",
        "selfSignup.guardian.emailOptional": "保護者メール（任意）",
        "selfSignup.cancel.title": "登録がキャンセルされました。",
        "selfSignup.cancel.description": "画面を閉じてください。",
        "selfSignup.complete.title": "患者登録申請が完了しました！",
        "selfSignup.complete.description1": "担当医療スタッフの承認後、入力された携帯電話番号にアカウント作成リンクが送信されます。",
        "selfSignup.complete.description2": "リンクを通じてアカウントを作成すると、治療プログラムをご利用いただけます。",
        "selfSignup.complete.note": "※ メッセージが届かない場合は、スパムフィルターをご確認ください。",
        "selfSignup.bottomSheet.dataError.title": "データエラー",
        "selfSignup.bottomSheet.dataError.description": "ボトムシートに必要なデータが不足しています。",
        "selfSignup.bottomSheet.dataError.errorType": "エラータイプ",
        "selfSignup.bottomSheet.dataError.missingFields": "不足フィールド",
        "selfSignup.bottomSheet.dataError.developerNote": "開発者向け：各エラータイプに適した正しいデータを渡してください。",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.title": "既に登録済みの保護者です",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.description": "この電話番号で既に登録された保護者がいます。",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.detailInfo": "登録患者：（{{patientName}}）",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.okButton": "確認",
        "selfSignup.bottomSheet.alreadyRegisteredGuardian.cancelButton": "キャンセル",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.title": "既に登録済みの患者です",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.description": "この情報で既に登録された患者がいます。",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.patientNameGender": "患者名/性別",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.birthDate": "生年月日",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.guardianName": "保護者名",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.guardianPhoneNumber": "保護者電話番号",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.guardianEmail": "保護者メール",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.okButton": "確認",
        "selfSignup.bottomSheet.alreadyRegisteredPatient.cancelButton": "キャンセル",
        "selfSignup.bottomSheet.alreadyReadySignup.title": "登録待ちの患者です",
        "selfSignup.bottomSheet.alreadyReadySignup.description": "この情報で既に登録申請が進行中です。",
        "selfSignup.bottomSheet.alreadyReadySignup.patientNameGender": "患者名/性別",
        "selfSignup.bottomSheet.alreadyReadySignup.birthDate": "生年月日",
        "selfSignup.bottomSheet.alreadyReadySignup.guardianName": "保護者名",
        "selfSignup.bottomSheet.alreadyReadySignup.guardianPhoneNumber": "保護者電話番号",
        "selfSignup.bottomSheet.alreadyReadySignup.guardianEmail": "保護者メール",
        "selfSignup.bottomSheet.alreadyReadySignup.okButton": "確認",
        "selfSignup.bottomSheet.alreadyReadySignup.cancelButton": "キャンセル",
        "common.close": "閉じる",
        "common.errorCode": "(エラーコード : {{code}})",
        "common.patient": "患者",
        "common.day": "日",
        "common.previous": "前へ",
        "common.next": "次へ",
        "common.count": "回数",
        "common.times": "回",
        "common.coordinate": "座標",
        "common.xCoordinate": "X座標",
        "common.yCoordinate": "Y座標",
        "common.eyePosition": "動き回数",
        "common.loadingChart": "チャートを読み込み中...",
        "common.dayProgress": "({{day}}日目)",
        "activityChart.chartDescription": "患者が治療活動を行う間にリアルタイムで測定された眼球の動き座標を可視化したグラフです。",
        "activityChart.xAxisHint": "(左右の動き)",
        "activityChart.yAxisHint": "(上下の動き)",
        "activityChart.timeLabel": "時間 (秒)",
        "activityChart.gazePosition": "視線位置",
        "activityChart.gazePositionX": "視線位置 (X軸)",
        "activityChart.gazePositionY": "視線位置 (Y軸)",
        "common.addPatient": "患者追加",
        "common.toast.patientPending": "患者が登録待ちです。",
        "common.toast.registerButton": "登録",
        "common.toast.unknownError": "不明なエラーが発生しました。",
        "common.auth.sendCode": "認証番号送信",
        "common.auth.resendCode": "認証番号再送信",
        "selfSignup.header.title": "お子様の登録",
        "selfSignup.welcome.greeting": "こんにちは。",
        "selfSignup.welcome.hospitalSuffix": " 病院です。",
        "selfSignup.welcome.needRegistrationLine1": "SAT001 を開始するには",
        "selfSignup.welcome.needRegistrationLine2": "お子様の登録が必要です。",
        "selfSignup.welcome.privacyNotice": "本人確認で収集した個人情報はサービス以外の目的で使用しません。",
        "selfSignup.welcome.startRegistration": "登録を開始",
        "selfSignup.notAllowed.title": "アクセス制限",
        "selfSignup.notAllowed.message": "承認されていない病院コードです。",
        "selfSignup.notAllowed.description": "正しい病院コードで再試行してください。",
        "appAccount.checkName.description": "{{APP_PRODUCT_NAME}} のIDとパスワードを設定するために\n本人確認を行ってください。",
        "appAccount.checkName.guardianName": "保護者名",
        "appAccount.checkName.placeholderGuardianName": "名前を入力してください",
        "appAccount.common.checking": "確認中...",
        "appAccount.complete.title": "アカウント設定が完了しました。",
        "appAccount.complete.description": "設定したアカウントで {{APP_PRODUCT_NAME}} を開始できます。",
        "appAccount.complete.hint": "下のログインボタンを押して {{APP_PRODUCT_NAME}} を開始してください。",
        "appAccount.complete.login": "ログイン",
        "appAccount.expired.title": "アカウント設定リンクの有効期限が切れました。",
        "appAccount.expired.beforeSetup": "<point>設定前</point>の場合は、登録した病院に設定メッセージの再送信を依頼してください。",
        "appAccount.expired.afterSetup": "<point>設定完了</point>後は、{{APP_PRODUCT_NAME}}を開始してください。",
        "appAccount.common.next": "次へ",
        "appAccount.common.userId": "ユーザーID",
        "appAccount.common.password": "パスワード",
        "appAccount.setupAccount.description": "{{APP_PRODUCT_NAME}} のIDとパスワードを設定してください。",
        "appAccount.setupAccount.placeholderUserId": "ユーザーIDを入力してください",
        "appAccount.setupAccount.placeholderPassword": "パスワードを入力してください",
        "appAccount.setupAccount.passwordConfirm": "パスワード確認",
        "appAccount.setupAccount.placeholderPasswordConfirm": "パスワードをもう一度入力してください",
        "findPassword.requestComplete.title": "メール送信が完了しました",
        "findPassword.requestComplete.sentTo": "パスワード再設定メールを送信しました: ",
        "findPassword.requestComplete.setNewPassword": "新しいパスワードを設定してください。",
        "findPassword.requestComplete.checkSpam": "メールが届かない場合は迷惑メールフォルダをご確認ください。",
        "findPassword.token.title": "パスワード再設定",
        "findPassword.token.placeholderNewPassword": "新しいパスワードを入力してください",
        "findPassword.token.placeholderConfirmPassword": "パスワードを再入力してください",
        "findPassword.token.submit": "パスワードを変更",
        "findPassword.codeValidation.title": "パスワード再設定コードを入力",
        "findPassword.codeValidation.description": " に送信されたパスワード再設定コードを入力してください。",
        "findPassword.common.next": "次へ",
        "findPassword.requestLink.title": "パスワードを探す",
        "findPassword.requestLink.description": "パスワード再設定コードを受け取るメールアドレスを入力してください。",
        "findPassword.requestLink.placeholderEmail": "メールアドレスを入力してください",

        "findPassword.viewModel.error.title": "エラーが発生しました",
        "findPassword.viewModel.error.description": "不明なエラーが発生しました。しばらくしてから再試行してください。",
        "findPassword.viewModel.error.confirm": "確認",
        "findPassword.viewModel.invalidToken.title": "無効なトークン",
        "findPassword.viewModel.invalidToken.description": "パスワード再設定リンクが無効です。ログイン画面に移動します。",
        "findPassword.viewModel.passwordMismatch": "パスワードが一致しません。",
        "findPassword.viewModel.passwordChangeComplete.title": "パスワード変更完了",
        "findPassword.viewModel.passwordChangeComplete.description": "パスワード変更が完了しました。ログイン画面に移動します。",
        "findPassword.viewModel.passwordValidation.length": "8-20文字",
        "findPassword.viewModel.passwordValidation.letter": "英字を含む",
        "findPassword.viewModel.passwordValidation.number": "数字を含む",
        "findPassword.viewModel.passwordValidation.special": "特殊文字(!@#$%^&*)を含む",
        "findPassword.viewModel.console.emailChange": "メール変更時に既存のエラーメッセージをクリア",
        "common.ok": "確認",
        "common.timeZoneDetection.title": "時刻改ざんの検知",
        "common.timeZoneDetection.description": "時刻の改ざんが検出されました。現在設定されている時刻が正しいかご確認のうえ、再度ログインしてください。",
        "common.agree": "同意",
        "common.gender.male": "男性",
        "common.gender.female": "女性",
        "common.date.format": "{{year}}年{{month}}月{{day}}日",
        "common.activity.LeftRightRail": "左右レール",
        "common.activity.Rotation": "回転",
        "common.activity.UpDown": "上下",
        "common.activity.FourWay": "上下左右",
        "common.activity.LeftRightRepeat": "左右反復",
        "common.activityState.notStarted": "未開始",
        "common.activityState.inProgress": "部分進行",
        "common.activityState.completed": "完了",

        "footer.medical.device.info": "医療機器情報",
        "footer.terms": "利用規約",
        "footer.privacy": "個人情報保護方針",
        "footer.language": "日本語",

        "language.ko": "한국어",
        "language.en": "English",
        "language.ja": "日本語",
        "footer.console.excludePath": "EXCLUDE_FOOTER_PATHに含まれているため、フッターを表示しません。",

        "login.email": "メールアドレスを入力してください",
        "login.password": "パスワードを入力してください",
        "login.forgotPassword": "パスワードを探す",
        "login.signIn": "ログイン",
        "login.signUp": "会員登録",
        "login.warning.registeredUsersOnly": "本システムは登録されたユーザーのみアクセス可能です。",
        "login.warning.monitoringAndRecording": "システムの使用は監視・記録の対象となり、無断使用は民事・刑事上の処罰を受ける可能性があります。",
        "login.warning.loginAgreement": "ログインは利用条件に同意することを意味します。",
        "login.remember": "メールを保存",
        "login.error": "ログインに失敗しました。もう一度お試しください。",
        "login.browserWarning.title": "別のブラウザの使用を推奨します",
        "login.browserWarning.description": "現在のブラウザでは一部の機能が制限される場合があります。ChromeまたはEdgeブラウザの使用を推奨します。",
        "login.browserWarning.okButton": "確認",
        "common.loading": "読み込み中...",
        "common.processing": "処理中...",

        "home.searchBarPlaceholder": "患者名で検索してください。",
        "home.titleAddNewPatient": "<b>新規患者を登録</b>してください",
        "home.addPatientByQR": "QR 簡単登録",
        "home.addPatientByDoctor": "患者登録",
        "home.titleAddNewPrescription": "<b>登録患者を確認</b>して<br /> <b>治療を追加</b>してください",
        "home.inProgressPatient": "治療中の患者",
        "home.personCountUnit": "名",
        "home.showPatientList": "患者一覧を見る",
        "home.searchHelp": "患者名を入力して検索してください",
        "home.actionLogs": "アクションログ",

        "patientList.patientNumber": "患者番号",
        "patientList.title": "患者一覧",
        "patientList.name": "患者名/性別",
        "patientList.deactive": "非活性化",
        "patientList.birthDay": "生年月日",
        "patientList.progress": "治療情報(治療段階/状態/参加度)",
        "patientList.memo": "メモ",
        "patientList.info": "患者情報",
        "patientList.filterPrescriptionAdd": "治療登録が可能な患者のみ表示",
        "patientList.filterByName": "名前で検索",
        "patientList.doctor": "先生",
        "patientList.emptyPatient": "登録された患者がいません。",
        "patientList.emptyPatientWithAddPrescriptionAvailable": "治療登録が可能な患者がいません。",
        "patientList.emptyFilteredPatient": "一致する患者がいません。",
        "patientList.emptyFilteredPatientWithName": "'<strong>{{name}}</strong>' の患者を登録してください。",
        "patientList.stepVisit": "第{{step}}回 診療",
        "patientList.progressInfo.inProgress": "進行中",
        "patientList.progressInfo.completed": "完了",
        "patientList.progressInfo.notStarted": "開始前",
        "patientList.progressInfo.interrupted": "中断",
        "patientList.progressInfo.canceled": "取消",
        "patientList.progressInfo.noActivityStepsInProgress": "進行中の活動段階なし",
        "patientList.progressInfo.beforeStart": "開始前",
        "patientList.addTreatmentBt": "治療期間の設定",
        "patientList.birthdayWithAge": "{{date}}/満 {{age}}歳",

        "addTreatment.title": "治療登録",
        "addTreatment.patientInfo": "患者情報",
        "addTreatment.patientNameGender": "患者名/性別",
        "addTreatment.birthDate": "生年月日",
        "addTreatment.treatmentInfo": "治療情報",
        "addTreatment.treatmentStep": "治療回",
        "addTreatment.treatmentPeriod": "治療期間",
        "addTreatment.hospitalVisitDate": "病院訪問日",
        "addTreatment.hospitalVisitDescription": " に病院を訪問して次の回の治療を登録してください。",
        "addTreatment.memo": "メモ",
        "addTreatment.memoPlaceholder": "特記事項や参考事項を入力してください",
        "addTreatment.cancel": "取消",
        "addTreatment.submit": "期間を設定",
        "addTreatment.treatmentStepUnit": "回 治療",
        "addTreatment.week14": "14週間",
        "addTreatment.error.title": "治療期間設定に失敗",
        "addTreatment.error.description": "治療期間の設定に失敗しました。",

        "patientTreatmentInfoCard.title": "治療現況",
        "patientTreatmentInfoCard.editTreatmentDuration": "治療期間の設定",
        "patientTreatmentInfoCard.noData": "データがありません",
        "patientTreatmentInfoCard.columns.treatmentStep": "治療段階",
        "patientTreatmentInfoCard.columns.period": "期間",
        "patientTreatmentInfoCard.columns.date": "日付",
        "patientTreatmentInfoCard.columns.state": "状態",
        "patientTreatmentInfoCard.columns.activityTime": "活動時間",
        "patientTreatmentInfoCard.columns.activityTimeSubHeader": "実施時間(推奨時間)",
        "patientTreatmentInfoCard.columns.adherence": "参加度",
        "patientTreatmentInfoCard.columns.doctor": "担当医",
        "patientTreatmentInfoCard.columns.dayLabel": "日目",
        "patientTreatmentInfoCard.summaryCard.inProgressTreatment": "進行中の治療現況",
        "patientTreatmentInfoCard.summaryCard.totalAdherence": "全体参加度",
        "patientTreatmentInfoCard.stepUnit": "回",
        "patientTreatmentInfoCard.units.step": "回",
        "patientTreatmentInfoCard.units.day": "日",
        "patientTreatmentInfoCard.units.minute": "分",

        "patientDetail.error.title": "患者詳細の読み込みに失敗",
        "patientDetail.error.description": "患者詳細情報の読み込みに失敗しました。しばらくしてから再試行してください。",
        "patientDetail.button.confirm": "確認",
        "patientDetail.emptyTreatmentCard.noTreatment": "進行中の治療はありません。",
        "patientDetail.deactivatedInfoLabel": "この患者は無効化されています。治療追加や情報修正には有効化してください。",
        "patientDetail.activate": "有効化",
        "patientDetail.showChart": "チャートを見る",
        "patientDetail.showDetail": "詳細を見る",
        "patientDetail.lightEstimation": "明るい光の認証",

        "patientGuardianInputForm.guardianInfo": "保護者情報",
        "patientGuardianInputForm.patientInfo": "患者情報",
        "patientGuardianInputForm.patientName": "患者名/性別",
        "patientGuardianInputForm.patientNamePlaceholder": "山田太郎",
        "patientGuardianInputForm.patientBirthDate": "生年月日",
        "patientGuardianInputForm.patientGender": "患者の性別",
        "patientGuardianInputForm.patientMemo": "メモ",
        "patientGuardianInputForm.guardianName": "保護者の名前",
        "patientGuardianInputForm.guardianNamePlaceholder": "山田太郎",
        "patientGuardianInputForm.guardianPhoneNumber": "保護者の電話番号",
        "patientGuardianInputForm.guardianEmail": "保護者メール",
        "patientGuardianInputForm.required": "必須",
        "patientGuardianInputForm.optional": "任意",

        "breadcrumbs.home": "ホーム",
        "breadcrumbs.profile": "プロフィール情報",
        "breadcrumbs.patientList": "患者一覧",
        "breadcrumbs.addPatient": "患者登録",
        "breadcrumbs.patientDetail": "患者詳細",
        "breadcrumbs.addTreatment": "治療期間設定",
        "breadcrumbs.treatmentProgress": "治療進行状況",
        "breadcrumbs.medicalDeviceInfo": "医療機器情報",
        "breadcrumbs.adminHome": "管理者ホーム",
        "breadcrumbs.adminDoctors": "医療スタッフ管理",
        "breadcrumbs.doctorDetail": "医療スタッフ詳細",
        "breadcrumbs.adminHospitals": "病院管理",
        "breadcrumbs.adminAddHospital": "病院追加",
        "breadcrumbs.adminPatients": "患者一覧",
        "breadcrumbs.adminLogs": "ログ",
        "breadcrumbs.adminActionLogs": "アクションログ",
        "breadcrumbs.actionLogs": "アクションログ",
        "breadcrumbs.adminAddDoctor": "医療スタッフ追加",
        "breadcrumbs.adminEditNotice": "お知らせ編集",
        "breadcrumbs.adminAddNotice": "お知らせ追加",
        "breadcrumbs.adminNotices": "お知らせ一覧",
        "breadcrumbs.noticeDetail": "お知らせ詳細",
        "breadcrumbs.myInfo": "マイ情報",
        "breadcrumbs.passwordChange": "パスワード変更",

        "errorPage.defaultMessage": "問題が発生しました。しばらくしてからもう一度お試しください。",
        "errorPage.error": "エラー",
        "errorPage.retry": "再試行",
        "errorPage.contact": "お問い合わせ: salpha@salphadtx.com",

        "phoneAuthCodeInput.placeholder": "送信された6桁の認証コードを入力してください",

        "customDatepicker.dateSelection": "日付選択",
        "customDatepicker.cancel": "取消",
        "customDatepicker.select": "選択",

        "qrModal.hospitalName": "病院名",
        "qrModal.scanQRCode": "保護者のスマートフォンでQRコードをスキャンしてください",
        "qrModal.useDefaultCamera": "デフォルトのカメラアプリを使用してください",
        "qrModal.directRegistration": "患者情報を直接登録",
        "qrModal.complete": "完了",
        "qrModal.close": "閉じる",

        "header.userManual": "ユーザーガイドを見る",
        "header.hospital": "病院",
        "header.changePassword": "パスワード変更",
        "header.logout": "ログアウト",
        "header.doctor": "{{doctorName}} 先生",
        "header.console.registerAction": "登録",
        "header.console.logoutAction": "デフォルトログアウトロジックを実行",

        "patientInfoCard.accountSetupMessageResend": "アカウント設定メッセージを再送",
        "patientInfoCard.editInfo": "情報修正",
        "patientInfoCard.editInfoButton": "設定完了",
        "patientInfoCard.patientNumber": "患者番号",
        "patientInfoCard.guardianName": "保護者の名前",
        "patientInfoCard.guardianEmail": "保護者メール",
        "patientInfoCard.guardianContact": "保護者の電話番号",
        "patientInfoCard.memo": "メモ",
        "patientInfoCard.noMemo": "-",

        "component.loading.text": "読み込み中...",
        "component.dropdown.defaultPlaceholder": "デフォルト値を入力してください",
        "component.dropdown.arrow": "矢印",
        "component.sectionGroup.deactivatePatient": "患者を無効化",
        "component.sectionGroup.deactivateDoctor": "アカウントを無効化",
        "validation.email.required": "メールアドレスを入力してください。",
        "validation.email.invalidFormat": "正しい形式のメールアドレスを入力してください。",
        "validation.password.required": "パスワードを入力してください。",
        "validation.password.conditions": "パスワード条件を満たしていません。",
        "validation.password.changeComplete": "パスワード変更完了",
        "validation.password.changeCompleteMessage": "パスワード変更が完了しました。",
        "password.change.initial.title": "初期パスワード変更",
        "password.change.expired.title": "期限切れパスワード変更",
        "password.change.default.title": "パスワード変更",
        "password.change.initial.description": "より安全なサービス利用のために初期パスワードを変更してください。",
        "password.change.expired.description": "より安全なサービス利用のために6か月ごとに新しいパスワードに変更してください。",
        "password.change.default.description": "新しいパスワードに変更してください。",
        "validation.userId.required": "ユーザーIDを入力してください。",
        "validation.userId.length": "6-16文字以内",
        "validation.userId.format": "英小文字・数字のみ使用可能",
        "validation.userId.duplicate": "このユーザーIDは既に使用されています。",
        "validation.password.confirmRequired": "パスワード確認を入力してください。",
        "validation.password.minimum": "パスワードは8文字以上である必要があります。",
        "validation.phone.invalidFormat": "携帯電話番号の形式が正しくありません。",
        "validation.phone.required": "電話番号を入力してください。",
        "validation.phone.authRequired": "電話番号認証を完了してください。",
        "validation.phone.authInvalid": "認証コードが正しくありません。",
        "validation.name.minimum": "名前は2文字以上入力してください。",
        "validation.name.required": "名前を入力してください。",
        "validation.name.noNumbers": "名前に数字は使用できません。",
        "validation.name.noSpecialChars": "名前に記号は使用できません。",
        "validation.name.allowedChars": "名前は韓国語、英字、スペースのみ入力できます。",
        "validation.name.invalidFormat": "正しい名前形式で入力してください。",
        "notice.validation.titleEmpty": "タイトルを入力してください",
        "notice.validation.contentEmpty": "内容を入力してください",
        "notice.validation.endDateBeforeStartDate": "終了日が開始日より前の場合は、終了日を開始日に調整してください",
        "notice.validation.versionEmpty": "バージョンを入力してください",
        "notice.validation.errorTitle": "お知らせ登録エラー",
        "notice.validation.confirmButton": "確認",
        "validation.birthDate.required": "生年月日を選択してください。",
        "validation.guardianName.minimum": "保護者名は2文字以上入力してください。",
        "addTreatment.confirmEndCurrent": "現在の治療終了確認",
        "addTreatment.confirmEndCurrentDescription": "現在進行中の治療を終了して新しい治療を開始しますか？",
        "patientDetail.updateFailed": "患者情報更新失敗",
        "patientDetail.updateComplete": "患者情報更新完了",
        "patientDetail.updateCompleteMessage": "患者情報が更新されました。",
        "patientDetail.deactivateTitle": "患者アカウント無効化",
        "patientDetail.deactivateDescription": "患者アカウントを無効化します。進行中の治療は中断され、今後治療登録を希望する場合は無効化を解除する必要があります。",
        "doctorDetail.deactivateTitle": "医療スタッフアカウント無効化",
        "doctorDetail.deactivateDescription": "医療スタッフアカウントを無効化します。ログインおよびすべてのサービス利用が制限され、再使用時には無効化解除が必要です。",
        "doctorDetail.deactivatedInfoLabel": "この医師は無効化されています。ログインや情報修正などの機能を使用するには、無効化を解除してください。",
        "doctorDetail.activate": "有効化",
        "patientDetail.activateTitle": "患者アカウント有効化",
        "patientDetail.activateDescription": "有効化後、処方が可能になります。続行しますか？",
        "errorPage.networkError": "ネットワークエラーが発生しました",
        "patientInfoCard.accountSetupMessageSent": "保護者アカウント作成のための案内メッセージを送信しました。ご確認ください。",
        "selfSignup.registrationFailed": "患者登録失敗",
        "selfSignup.saveFailed": "患者情報の保存に失敗しました。再試行してください。",
        "selfSignup.saveFailedTitle": "保存失敗",
        "selfSignup.authCodeSendFailed": "認証コード送信失敗",
        "addPatient.duplicatePatient": "既に登録済みの患者情報です",
        "addPatient.duplicatePatientDescription": "同じ情報で既に登録された患者がいるため、重複登録はできません。入力した患者情報をご確認ください。",
        "addPatient.reEnter": "再入力",
        "addPatient.viewRegisteredPatient": "登録済み患者情報を見る",
        "addPatient.invalidGuardianPhoneNumberTitle": "保護者の電話番号をご確認ください",
        "addPatient.invalidGuardianPhoneNumberDescription": "入力された電話番号 ({{guardianPhoneNumber}}) は、他の患者の保護者として既に登録されています。",
        "addPatient.reInputGuardianPhoneNumber": "正しい電話番号を再入力してください",
        "common.cancel": "キャンセル",
        "treatmentDetail.cancelComplete": "治療キャンセル完了",
        "treatmentDetail.cancelCompleteMessage": "現在の処方が正常にキャンセルされました。患者情報に移動します。",
        "treatmentDetail.confirmStop": "治療キャンセル確認",
        "treatmentDetail.confirmStopDescription": "進行中の治療をキャンセルしますか？",
        "treatmentDetail.chartDataLoadFailed": "治療チャートデータ取得失敗",
        "treatmentDetail.chartDataLoadFailedMessage": "治療チャートデータを取得できません。",
        "findPassword.viewModel.authError": "メール、認証情報エラー",
        "findPassword.viewModel.authErrorMessage": "メールまたは認証情報エラーが発生しました。再試行してください。",
        "validation.guardianName.required": "保護者名を入力してください。",
        "validation.guardianName.mismatch": "保護者名が一致しません。\n病院に登録した保護者名と同一に入力してください",
        "passwordChange.currentPasswordPlaceholder": "現在のパスワードを入力してください",
        "passwordChange.newPasswordPlaceholder": "新しいパスワードを入力してください",
        "passwordChange.confirmPasswordPlaceholder": "パスワードを再入力してください",
        "passwordChange.changeButton": "パスワード変更",
        "treatmentDetail.summaryTitle": "{{step}}次治療内容要約",
        "treatmentDetail.progressTitle": "{{step}}次治療進行現況",
        "treatmentDetail.noProgressData": "進行現況がありません。",
        "treatmentDetail.memoPlaceholder": "特異事項や参考事項を入力してください。",
        "treatmentDetail.memoSave": "保存",
        "treatmentDetail.memoEdit": "修正",
        "treatmentDetail.stopTreatment": "治療中断",
        "errorPage.tryAgainLater": "しばらくしてから再試行してください。",
        "test.newKey1": "新しい翻訳キー1",
        "test.newKey2": "新しい翻訳キー2",
        "test.newKey3": "新しい翻訳キー3",
        "admin.doctorList.title": "医療従事者管理",
        "admin.doctorList.searchPlaceholder": "氏名、病院名",
        "admin.doctorList.nameHeader": "医師名",
        "admin.doctorList.licenseHeader": "免許番号",
        "admin.doctorList.hospitalHeader": "所属病院",
        "admin.doctorList.hospitalPhoneHeader": "病院連絡先",
        "admin.doctorList.treatmentCountHeader": "登録治療数",
        "admin.doctorList.emptySearchResult": "検索結果がありません。",
        "admin.doctorList.emptyList": "登録された医療従事者がいません。",
        "admin.doctorList.addDoctorPrompt": "医療従事者を登録しますか？",
        "admin.doctorList.addDoctorButton": "医療従事者追加",
        "admin.addDoctor.title": "医療従事者登録",
        "admin.addDoctor.doctorNameLabel": "医師名",
        "admin.addDoctor.doctorNamePlaceholder": "山田太郎",
        "admin.addDoctor.licenseNumberLabel": "免許番号",
        "admin.addDoctor.licenseNumberPlaceholder": "01-123456",
        "admin.addDoctor.hospitalLabel": "所属病院",
        "admin.addDoctor.hospitalPlaceholder": "病院名を入力してください",
        "admin.addDoctor.hospitalPhoneLabel": "病院電話番号",
        "admin.addDoctor.hospitalPhonePlaceholder": "03-1234-5678",
        "admin.addDoctor.doctorEmailLabel": "メール",
        "admin.addDoctor.hospitalEmailLabel": "病院メール",
        "admin.addDoctor.emailPlaceholder": "salpha@salphadtx.com",
        "admin.addDoctor.memoLabel": "メモ",
        "admin.addDoctor.memoPlaceholder": "特記事項や参考事項を入力してください",
        "admin.addDoctor.cancelButton": "キャンセル",
        "admin.addDoctor.submitButton": "医療従事者登録",
        "admin.addDoctor.successTitle": "医療従事者登録完了",
        "admin.addDoctor.successMessage": "医療従事者が正常に登録されました。",
        "admin.addDoctor.doctorNameRequired": "医師名を入力してください。",
        "admin.addDoctor.licenseNumberRequired": "免許番号を入力してください。",
        "admin.addDoctor.hospitalRequired": "所属病院を入力してください。",
        "admin.addDoctor.selectHospital": "病院を選択してください",
        "admin.addDoctor.addHospital": "病院追加",
        "admin.addDoctor.noHospitalFound": "検索された病院がありません",
        "admin.addDoctor.doctorEmailRequired": "メールアドレスを入力してください。",
        "admin.addDoctor.hospitalPhoneInvalid": "正しい電話番号形式を入力してください。",
        "admin.addDoctor.registrationFailed": "医療従事者登録に失敗しました。再度お試しください。",
        "admin.doctorDetail.editInfo": "情報編集",
        "admin.doctorDetail.editInfoButton": "設定完了",
        "admin.doctorDetail.editTitle": "医療スタッフ情報編集",
        "admin.doctorDetail.doctorNameLabel": "医療スタッフ名",
        "admin.doctorDetail.doctorNamePlaceholder": "医療スタッフ名を入力してください",
        "admin.doctorDetail.hospitalNamePlaceholder": "病院名を入力してください",
        "admin.doctorDetail.memoPlaceholder": "メモを入力してください",
        "admin.doctorDetail.doctorId": "医療スタッフID",
        "admin.doctorDetail.email": "メール",
        "admin.doctorDetail.hospital": "所属病院",
        "admin.doctorDetail.memo": "メモ",
        "admin.doctorDetail.registeredTreatments": "{{ProductName}} 登録された治療一覧",
        "admin.doctorDetail.treatmentTable.createdAt": "登録時間",
        "admin.doctorDetail.treatmentTable.patientId": "患者ID",
        "admin.doctorDetail.treatmentTable.treatmentId": "処方ID",
        "admin.doctorDetail.treatmentTable.stepAndPeriod": "登録回数/期間",
        "admin.doctorDetail.treatmentTable.step": "Step",
        "admin.doctorDetail.treatmentTable.type": "Type",
        "admin.doctorDetail.treatmentTable.stepUnit": "回",
        "admin.doctorDetail.treatmentTable.weekUnit": "週",
        "admin.doctorDetail.treatmentTable.empty": "登録された処方がありません",
        "admin.doctorDetail.treatmentTable.cancelled": "キャンセル済み",
        "admin.doctorDetail.treatmentCountLabel": "登録治療数",
        "admin.doctorDetail.filter.all": "すべて",
        "admin.doctorDetail.filter.createdAt": "登録時間",
        "admin.doctorDetail.filter.patientId": "患者ID",
        "admin.doctorDetail.filter.treatmentId": "処方ID",
        "admin.doctorDetail.filter.placeholder.all": "日付、患者ID、処方IDで検索",
        "admin.doctorDetail.filter.placeholder.createdAt": "日付を入力してください（例：2024-01-01）",
        "admin.doctorDetail.filter.placeholder.patientId": "患者IDを入力してください",
        "admin.doctorDetail.filter.placeholder.treatmentId": "処方IDを入力してください",
        "admin.addHospital.title": "病院情報",
        "admin.addHospital.hospitalNameLabel": "病院名",
        "admin.addHospital.hospitalNamePlaceholder": "病院の正式名称を入力してください",
        "admin.addHospital.hospitalCodeLabel": "病院コード",
        "admin.addHospital.hospitalCodePlaceholder": "ABC（英字3文字）",
        "admin.addHospital.cancelButton": "キャンセル",
        "admin.addHospital.submitButton": "登録",
        "admin.addHospital.hospitalNameRequired": "病院の正式名称を入力してください。",
        "admin.addHospital.hospitalNameMinLength": "病院の正式名称は2文字以上入力してください。",
        "admin.addHospital.hospitalNameFormat": "病院名は韓国語、英語、数字、スペースのみ入力可能です。",
        "admin.addHospital.hospitalCodeRequired": "病院コードを入力してください。",
        "admin.addHospital.hospitalCodeFormat": "病院コードは英字3文字で入力してください。",

        "admin.home.hospitalList": "病院一覧",
        "admin.home.notice": "お知らせ",
        "notice.title": "お知らせ",
        "notice.delete": "削除",
        "notice.create": "作成",
        "notice.searchPlaceholder": "タイトル、登録者、ビルド番号で検索",
        "notice.noData": "お知らせデータがありません。",
        "notice.table.title": "タイトル",
        "notice.table.author": "登録者",
        "notice.table.publishPeriod": "掲載期間",
        "notice.table.lastModified": "最終更新日時",
        "notice.table.buildNumber": "ビルド番号",
        "notice.table.edit": "編集",
        "notice.important": "重要",
        "notice.add.title": "お知らせ作成",
        "notice.add.titleLabel": "タイトル",
        "notice.add.titlePlaceholder": "タイトルを入力してください",
        "notice.add.publishPeriod": "掲載期間",
        "notice.add.buildNumber": "ビルド番号",
        "notice.add.content": "本文",
        "notice.add.contentPlaceholder": "内容を入力してください",
        "notice.add.exposeAllVersions": "すべてのバージョンに表示",
        "notice.add.cancel": "キャンセル",
        "notice.add.submit": "登録",
        "notice.edit.title": "お知らせ編集",
        "notice.edit.cancel": "キャンセル",
        "notice.edit.submit": "更新",
        "notice.edit.delete": "削除",
        "notice.edit.notFound": "お知らせが見つかりません。",
        "notice.detail.title": "お知らせ詳細",
        "notice.detail.author": "作成者",
        "notice.detail.publishPeriod": "掲載期間",
        "notice.detail.lastModified": "最終更新日時",
        "notice.detail.buildNumber": "ビルド番号",
        "notice.detail.edit": "編集",
        "notice.modal.deleteTitle": "お知らせ削除",
        "notice.modal.deleteMessage": "選択された{{count}}件の投稿を削除しますか？",
        "notice.modal.deleteButton": "削除",
        "notice.modal.cancelButton": "キャンセル",
        "notice.modal.noNoticesToDelete": "削除するお知らせがありません",
        "notice.toast.deleteSuccess": "{{count}}件のお知らせを削除しました。",
        "notice.edit.successMessage": "お知らせの更新に成功しました",
        "notice.edit.cancelTitle": "作成キャンセル確認",
        "notice.edit.cancelMessage": "作成をキャンセルしますか？ \n 現在入力した内容は保存されずに失われます。",
        "notice.edit.cancelButton": "キャンセル",
        "notice.edit.continueButton": "作成を続ける",
        "notice.edit.deleteTitle": "投稿削除",
        "notice.edit.deleteMessage": "この投稿を削除しますか？",
        "notice.edit.deleteButton": "削除",
        "notice.edit.deleteSuccessMessage": "お知らせの削除に成功しました",
        "notice.add.successMessage": "お知らせの登録に成功しました",
        "component.sectionGroup.registerAsImportantNotice": "重要なお知らせとして登録",
        "pagination.itemsPerPage": "ページあたりの項目数",
        "pagination.page": "ページ",
        "pagination.of": "の",
        "pagination.total": "合計",
        "pagination.items": "項目",
        "log.table.occurredAt": "発生時刻",
        "log.table.type": "タイプ",
        "log.table.event": "イベント",
        "log.table.user": "ユーザー",
        "log.table.targetUser": "ターゲットユーザー",
        "log.table.activityDetails": "活動詳細",
        "log.noData": "ログデータがありません。",
        "log.noFilteredData": "フィルタリングされたログデータがありません。",
        "log.searchPlaceholder": "ID",
        "log.copiedMessage": "値がコピーされました。",
        "log.modal.okButton": "確認",
        "actionLog.tabs.all": "すべて",
        "actionLog.table.occurredAt": "発生時刻",
        "actionLog.table.eventType": "タイプ",
        "actionLog.table.eventAction": "アクション",
        "actionLog.table.component": "コンポーネント",
        "actionLog.table.parameter": "パラメータ",
        "actionLog.table.pageScene": "ページ",
        "actionLog.noData": "アクションログデータがありません。",
        "actionLog.searchRequired": "スクリーニングIDを検索してください。",
        "actionLog.searchPlaceholder": "スクリーニングID",
        "header.admin": "管理者",
        "hospital.table.hospitalName": "病院名",
        "hospital.table.hospitalCode": "病院コード",
        "hospital.table.doctorCount": "登録医療スタッフ数",
        "hospital.table.patientCount": "登録患者数",
        "hospital.delete": "削除",
        "hospital.register": "登録",
        "hospital.searchPlaceholder": "病院名またはコードで検索",
        "hospital.noData": "病院データがありません。",
        "hospital.noSearchResults": "検索結果がありません。",
        "hospital.noSearchResultsWithQuery": "「{{query}}」で検索された項目がありません。",
        "hospital.disabledMessage.hasDoctorsAndPatients": "登録された医師と患者がいるため選択できません",
        "hospital.disabledMessage.hasDoctors": "登録された医師がいるため選択できません",
        "hospital.disabledMessage.hasPatients": "登録された患者がいるため選択できません",
        "admin.home.logs": "ログ表示",
        "admin.home.actionLogs": "アクションログ",
        "admin.home.addDoctor.line1": "医療従事者を登録",
        "admin.home.addDoctor.line1-1": "または",
        "admin.home.addDoctor.line2": "照会",
        "admin.home.addDoctor.line2-1": "してください",
        "admin.home.addDoctorButton": "医療従事者を登録",
        "admin.home.doctorListButton": "医療従事者一覧",
        "admin.home.searchPatient.line1": "登録された患者情報を",
        "admin.home.searchPatient.line1-1": "",
        "admin.home.searchPatient.line2": "確認してください",
        "admin.home.patientListButton": "患者一覧を見る",
        "toast.addPatient.successMessage": "新規患者が登録されました。",
        "toast.addDoctor.successMessage": "医療従事者が正常に登録されました。",
        "toast.addHospital.successMessage": "病院が正常に登録されました。",
        "toast.deleteHospital.successMessage": "病院が正常に削除されました。",
        "toast.addPrescription.successMessage": "治療期間が設定されました。",
        "toast.terminateTreatment.successMessage": "治療が中断されました。",
        "toast.patient.inactive.successMessage": "患者が無効化されました。",
        "toast.doctor.inactive.successMessage": "医師が無効化されました。",
        "toast.doctor.active.successMessage": "医師が有効化されました。",
        "toast.patient.active.successMessage": "患者が有効化されました。",
        "initPassword.title": "初期パスワード設定",
        "initPassword.newPasswordPlaceholder": "初期パスワードを入力してください",
        "initPassword.confirmPasswordPlaceholder": "パスワードを再入力してください",
        "initPassword.processing": "処理中...",
        "initPassword.setPasswordButton": "パスワード設定",
        "admin.doctorDetail.doctorNameRequired": "医療スタッフ名を入力してください。",
        "admin.doctorDetail.hospitalRequired": "病院を選択してください。",
        "admin.doctorDetail.updateSuccessMessage": "医療スタッフ情報が更新されました",
        "admin.doctorDetail.passwordResetSuccessMessage": "パスワード設定メッセージ再送信完了",
        "admin.doctorDetail.sendPasswordResetButton": "パスワード設定メッセージ再送信",

        "operationLog.tabs.all": "すべて",
        "operationLog.tabs.doctor": "医療者",
        "operationLog.tabs.patient": "患者",
        "operationLog.tabs.admin": "管理者",
        "operationLog.tabs.treatment": "治療",
        "medicalDevice.title": "医療機器情報",
        "medicalDevice.section1.title": "1. 製品情報",
        "medicalDevice.section1.manufacturingNumber": "製造番号/製造年月",
        "medicalDevice.section1.manufacturingNumber.value": "• 製造番号 : SAT00120260930\n• 製造年月 : 2026.09.30",
        "medicalDevice.section1.manufacturerName": "製造者商号",
        "medicalDevice.section1.manufacturerName.value": "（株）エスアルファセラピューティクス",
        "medicalDevice.section1.manufacturerAddress": "製造者住所",
        "medicalDevice.section1.manufacturerAddress.value": "ソウル特別市永登浦区陽山路91、608号室",
        "medicalDevice.section1.manufacturerContact": "製造者連絡先",
        "medicalDevice.section1.manufacturerContact.value": "02-3487-3923",
        "medicalDevice.section1.licenseNumber": "認証番号（承認番号）",
        "medicalDevice.section1.licenseNumber.value": "• デジタル医療機器製造認証番号 : D 製認 26-4035 号\n• 業許可番号 : D 業許可 10090 号",
        "medicalDevice.section1.productName": "製品名",
        "medicalDevice.section1.productName.value": "MyoHabit™",
        "medicalDevice.section1.productVersion": "製品バージョン",
        "medicalDevice.section1.productVersion.value": "v1.0.0(1)",
        "medicalDevice.section1.udi": "医療機器標準コード（UDI）",
        "medicalDevice.section1.udi.value": "GTIN (UDI-DI) : (01) 8800404790000\nSW-Version (UDI-PI) : (10) V1.0.0",
        "medicalDevice.section1.networkRequired": "ネットワーク必要有無",
        "medicalDevice.section1.networkRequired.value": "• 本製品は正常な使用のために継続的なインターネット接続が必要です。\n• 推奨ネットワーク環境：安定した有線または高速無線インターネット（最小アップロード/ダウンロード速度5Mbps以上）\n• 病院内のファイアウォール、セキュリティ機器などによる外部サーバーアクセス制限時、機能が正常に動作しない場合があります。",
        "medicalDevice.section1.minimumSpecs": "対応機器最小仕様",
        "medicalDevice.section1.minimumSpecs.value": "OS\n• Windows 10以上\n• macOS Monterey以上\n\nCPU\n• Intel Core i3以上\n• AMD Ryzen 3以上\n\nRAM\n• 4GB以上",
        "medicalDevice.section1.supportedBrowsers": "対応ブラウザ",
        "medicalDevice.section1.supportedBrowsers.value": "• 最新2バージョンのChrome\n• 最新2バージョンのEdge",
        "medicalDevice.section1.customerSupport": "カスタマーサポート情報",
        "medicalDevice.section1.customerSupport.value": "02-3487-3923",
        "medicalDevice.section2.title": "2. ユーザー用表示情報",
        "medicalDevice.section2.productDescription": "製品説明",
        "medicalDevice.section2.productDescription.value": "本製品は小児近視進行抑制のためのデジタル医療機器の処方管理に使用される専門家用デジタル医療機器ソフトウェアです。",
        "medicalDevice.section2.productDescription.highlight": "デジタル医療機器ソフトウェア",
        "medicalDevice.section2.usagePurpose": "使用目的",
        "medicalDevice.section2.usagePurpose.value": "眼科医療従事者を対象に、医療機関で近視と診断された患者に近視進行抑制治療プログラムの使用権限を付与し、進行状況をモニタリングできるように設計されたソフトウェアです。\n\nクラウドベースのサーバーと通信し、ウェブベースのUIを通じて医療従事者がアクセスできるように構成されています。",
        "medicalDevice.section2.usageMethod": "使用方法",
        "medicalDevice.section2.usageMethod.value": "ユーザーマニュアル参照",
        "medicalDevice.section2.contraindications": "禁忌事項および予想される副作用",
        "medicalDevice.section2.contraindications.value": "臨床試験結果、本製品に関連する副作用は報告されていません。",
        "medicalDevice.section2.warnings": "警告文",
        "medicalDevice.section2.warnings.value": "• 本製品は使用環境（例：ネットワーク接続状態、機器性能など）に応じて動作遅延、機能エラー、または予期しない終了現象が発生する場合があります。安定したネットワーク環境で推奨仕様以上の機器を使用してください。\n• 公共または未登録のネットワーク（Wi-Fiなど）の使用を控えてください。\n• 患者および保護者情報の漏洩に注意してください。\n• セキュリティ関連の問題発生時はカスタマーサポートセンターに連絡してください。\n• 医療従事者アカウント情報を他人と共有しないでください。\n• 使用後は必ずログアウトしてください。\n• 製品内の治療関連データ入力時、正確に入力したか再度確認してください。\n• 記載された使用目的以外の用途で使用しないでください。",
        "medicalDevice.section3.title": "3. サイバーセキュリティ関連案内事項",
        "medicalDevice.section3.link": "サイバーセキュリティインシデント案内",
        "medicalDevice.section4.title": "4. 使用上の注意事項",
        "medicalDevice.section4.link": "MyoHabit™ 使用上の注意事項",
        "medicalDevice.note.label": "参考",
        "medicalDevice.note.value": "本ウェブシステムはデジタル治療機器アプリの処方管理目的でのみ使用され、直接的な治療行為は連携された患者用アプリで実行されます。",
        "medicalDevice.table.header.item": "項目",
        "medicalDevice.table.header.content": "内容",
        "errorBoundary.title": "エラーが発生しました",
        "errorBoundary.message": "ページの読み込み中に問題が発生しました。",
        "errorBoundary.reload": "再読み込み",
        "initialModuleLoad.failureTitle": "初期モジュールの読み込み失敗",
        "initialModuleLoad.failureDescription": "安定したサービスのため、再読み込みが必要です。",
        "unknownError.title": "不明なエラー",
        "unknownError.description": "しばらくしてからもう一度お試しください。",
        "eventHubUnavailable.emailTitle": "メール送信失敗",
        "eventHubUnavailable.emailDescription": "一時的なサービスエラーによりメールを送信できませんでした。問題が続く場合はカスタマーセンターへお問い合わせください。",
        "eventHubUnavailable.smsTitle": "SMS送信失敗",
        "eventHubUnavailable.smsDescription": "一時的なサービスエラーによりメッセージを送信できませんでした。問題が続く場合はカスタマーセンターへお問い合わせください。",
      },
    },
  },
  lng: typeof window !== "undefined" ? localStorage.getItem("language") || "ko" : "ko",
  fallbackLng: ["ko", "en", "ja"],
  keySeparator: false,
  interpolation: {
    escapeValue: false,
    // 제품명은 상수 한 곳에서 관리한다. 문자열에서는 {{APP_PRODUCT_NAME}} 으로 쓰면 된다.
    defaultVariables: {
      APP_PRODUCT_NAME,
    },
  },
});

export const useTranslation = useTranslationOriginal;
export default i18next;
